import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _36x181 from "./36x181.png";
import _36x182 from "./36x182.png";
import _36x183 from "./36x183.png";
import _36x184 from "./36x184.png";

const width = '100'
const height = 'auto'
const viewBox = '0 0 1017 311'

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width}%;
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-61bdda9c5a-a'
        x1='-2369.92'
        x2='-2367.92'
        y1='305.67'
        y2='305.67'
        gradientTransform='matrix(-1 0 0 1 -2127.14 -220.08)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-q'
        x1='-2382.1'
        x2='-2381.85'
        y1='305.75'
        y2='305.75'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-r'
        x1='-2380.91'
        x2='-2380.66'
        y1='305.66'
        y2='305.66'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-s'
        x1='-2379.81'
        x2='-2379.56'
        y1='305.59'
        y2='305.59'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-t'
        x1='-2378.7'
        x2='-2378.45'
        y1='305.53'
        y2='305.53'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-u'
        x1='-2377.51'
        x2='-2377.26'
        y1='305.45'
        y2='305.45'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-v'
        x1='-2376.4'
        x2='-2376.15'
        y1='305.38'
        y2='305.38'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-w'
        x1='-2375.33'
        x2='-2375.08'
        y1='305.27'
        y2='305.27'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-x'
        x1='-2374.14'
        x2='-2373.89'
        y1='305.12'
        y2='305.12'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-y'
        x1='-2390'
        x2='-2389.75'
        y1='306.23'
        y2='306.23'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-z'
        x1='-2388.89'
        x2='-2388.64'
        y1='306.16'
        y2='306.16'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-A'
        x1='-2387.79'
        x2='-2387.54'
        y1='306.1'
        y2='306.1'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-B'
        x1='-2386.6'
        x2='-2386.35'
        y1='306.02'
        y2='306.02'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-C'
        x1='-2385.49'
        x2='-2385.24'
        y1='305.95'
        y2='305.95'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-D'
        x1='-2384.42'
        x2='-2384.17'
        y1='305.84'
        y2='305.84'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-E'
        x1='-2383.23'
        x2='-2382.98'
        y1='305.69'
        y2='305.69'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-F'
        x1='-2373.03'
        x2='-2372.78'
        y1='305.06'
        y2='305.06'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-G'
        x1='-2371.93'
        x2='-2371.68'
        y1='304.99'
        y2='304.99'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-H'
        x1='-2394.02'
        x2='-2373.9'
        y1='295.68'
        y2='295.68'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-I'
        x1='-2394.01'
        x2='-2373.99'
        y1='294.62'
        y2='294.62'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-J'
        x1='-2393.97'
        x2='-2373.99'
        y1='293.79'
        y2='293.79'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-K'
        x1='-2394.02'
        x2='-2373.9'
        y1='296.58'
        y2='296.58'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-L'
        x1='-2394.02'
        x2='-2373.91'
        y1='297.43'
        y2='297.43'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-M'
        x1='-2394.03'
        x2='-2373.91'
        y1='298.26'
        y2='298.26'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-N'
        x1='-2394.03'
        x2='-2373.91'
        y1='299.14'
        y2='299.14'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-O'
        x1='-2394.03'
        x2='-2373.91'
        y1='300.04'
        y2='300.04'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-P'
        x1='-2394.04'
        x2='-2373.92'
        y1='300.88'
        y2='300.88'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-Q'
        x1='-2394.04'
        x2='-2373.92'
        y1='301.72'
        y2='301.72'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-R'
        x1='-2394.04'
        x2='-2373.92'
        y1='302.62'
        y2='302.62'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-S'
        x1='-2394.05'
        x2='-2373.93'
        y1='303.53'
        y2='303.53'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-T'
        x1='-2394.05'
        x2='-2373.93'
        y1='304.37'
        y2='304.37'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-U'
        x1='-2394.05'
        x2='-2373.93'
        y1='305.2'
        y2='305.2'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-V'
        x1='-2394.06'
        x2='-2373.94'
        y1='306.08'
        y2='306.08'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-W'
        x1='-2394.06'
        x2='-2373.94'
        y1='306.99'
        y2='306.99'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-X'
        x1='-2394.06'
        x2='-2373.94'
        y1='307.83'
        y2='307.83'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-Y'
        x1='-2394.07'
        x2='-2373.95'
        y1='308.66'
        y2='308.66'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-Z'
        x1='-2394.07'
        x2='-2373.95'
        y1='309.51'
        y2='309.51'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aa'
        x1='-2394.07'
        x2='-2373.95'
        y1='310.41'
        y2='310.41'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ab'
        x1='-2394.08'
        x2='-2373.96'
        y1='311.26'
        y2='311.26'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ac'
        x1='-2394.08'
        x2='-2373.96'
        y1='312.09'
        y2='312.09'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ad'
        x1='-2394.08'
        x2='-2373.96'
        y1='312.97'
        y2='312.97'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ae'
        x1='-2394.09'
        x2='-2373.97'
        y1='313.87'
        y2='313.87'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-af'
        x1='-2394.09'
        x2='-2373.97'
        y1='314.72'
        y2='314.72'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ag'
        x1='-2394.09'
        x2='-2373.97'
        y1='315.55'
        y2='315.55'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ah'
        x1='-2394.1'
        x2='-2373.98'
        y1='316.46'
        y2='316.46'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ai'
        x1='-2394.1'
        x2='-2373.98'
        y1='317.36'
        y2='317.36'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aj'
        x1='-2394.1'
        x2='-2373.98'
        y1='318.2'
        y2='318.2'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ak'
        x1='-2394.1'
        x2='-2373.99'
        y1='319.04'
        y2='319.04'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-al'
        x1='-2394.11'
        x2='-2373.99'
        y1='319.92'
        y2='319.92'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-am'
        x1='-2394.11'
        x2='-2373.99'
        y1='320.78'
        y2='320.78'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-an'
        x1='269.58'
        x2='243.45'
        y1='295.52'
        y2='315.54'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ao'
        x1='-2393.71'
        x2='-2391.71'
        y1='307'
        y2='307'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <radialGradient
        id='s-61bdda9c5a-b'
        cx='246.79'
        cy='85.08'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-61bdda9c5a-c'
        x1='254.39'
        x2='254.42'
        y1='305.63'
        y2='305.12'
        gradientTransform='matrix(1.11 .01 .01 1 -35.47 -221.6)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-ap'
        x1='-2375.55'
        x2='-2375.3'
        y1='302.87'
        y2='302.87'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aq'
        x1='-2374.36'
        x2='-2374.11'
        y1='302.81'
        y2='302.81'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ar'
        x1='-2373.25'
        x2='-2373'
        y1='302.76'
        y2='302.76'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-as'
        x1='-2372.14'
        x2='-2371.89'
        y1='302.67'
        y2='302.67'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-at'
        x1='-2370.95'
        x2='-2370.7'
        y1='302.61'
        y2='302.61'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-au'
        x1='-2369.84'
        x2='-2369.59'
        y1='302.54'
        y2='302.54'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-av'
        x1='-2368.72'
        x2='-2368.47'
        y1='302.47'
        y2='302.47'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aw'
        x1='-2367.53'
        x2='-2367.28'
        y1='302.4'
        y2='302.4'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ax'
        x1='-2366.42'
        x2='-2366.17'
        y1='302.34'
        y2='302.34'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ay'
        x1='-2365.31'
        x2='-2365.06'
        y1='302.28'
        y2='302.28'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-az'
        x1='-2364.12'
        x2='-2363.87'
        y1='302.23'
        y2='302.23'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aA'
        x1='-2363.01'
        x2='-2362.76'
        y1='302.11'
        y2='302.11'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aB'
        x1='-2361.93'
        x2='-2361.68'
        y1='302.05'
        y2='302.05'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aC'
        x1='-2360.74'
        x2='-2360.49'
        y1='302.02'
        y2='302.02'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aD'
        x1='-2359.63'
        x2='-2359.38'
        y1='301.95'
        y2='301.95'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aE'
        x1='-2378.82'
        x2='-2362.54'
        y1='291.69'
        y2='291.69'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aF'
        x1='-2378.81'
        x2='-2362.53'
        y1='290.24'
        y2='290.24'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aG'
        x1='-2378.8'
        x2='-2362.53'
        y1='288.86'
        y2='288.86'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aH'
        x1='-2378.8'
        x2='-2362.52'
        y1='287.4'
        y2='287.4'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aI'
        x1='-2378.79'
        x2='-2362.52'
        y1='286.02'
        y2='286.02'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aJ'
        x1='-2378.93'
        x2='-2362.65'
        y1='321.38'
        y2='321.38'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aK'
        x1='-2378.93'
        x2='-2362.65'
        y1='322.59'
        y2='322.59'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aL'
        x1='-2378.92'
        x2='-2362.64'
        y1='320'
        y2='320'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aM'
        x1='-2378.91'
        x2='-2362.64'
        y1='318.55'
        y2='318.55'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aN'
        x1='-2378.91'
        x2='-2362.63'
        y1='317.17'
        y2='317.17'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aO'
        x1='-2378.9'
        x2='-2362.63'
        y1='315.71'
        y2='315.71'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aP'
        x1='-2378.9'
        x2='-2362.62'
        y1='314.33'
        y2='314.33'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aQ'
        x1='-2378.89'
        x2='-2362.62'
        y1='312.88'
        y2='312.88'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aR'
        x1='-2378.89'
        x2='-2362.61'
        y1='311.49'
        y2='311.49'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aS'
        x1='-2378.88'
        x2='-2362.61'
        y1='310.04'
        y2='310.04'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aT'
        x1='-2378.88'
        x2='-2362.6'
        y1='308.62'
        y2='308.62'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aU'
        x1='-2378.87'
        x2='-2362.6'
        y1='307.17'
        y2='307.17'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aV'
        x1='-2378.87'
        x2='-2362.59'
        y1='305.79'
        y2='305.79'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aW'
        x1='-2378.86'
        x2='-2362.59'
        y1='304.33'
        y2='304.33'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aX'
        x1='-2378.86'
        x2='-2362.58'
        y1='302.95'
        y2='302.95'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aY'
        x1='-2378.85'
        x2='-2362.57'
        y1='301.5'
        y2='301.5'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-aZ'
        x1='-2378.85'
        x2='-2362.57'
        y1='300.12'
        y2='300.12'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-ba'
        x1='-2378.84'
        x2='-2362.56'
        y1='298.66'
        y2='298.66'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-bb'
        x1='-2378.84'
        x2='-2362.56'
        y1='297.28'
        y2='297.28'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-bc'
        x1='-2378.83'
        x2='-2362.55'
        y1='295.83'
        y2='295.83'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-bd'
        x1='-2378.83'
        x2='-2362.55'
        y1='294.45'
        y2='294.45'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-be'
        x1='-2378.82'
        x2='-2362.54'
        y1='292.99'
        y2='292.99'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <linearGradient
        id='s-61bdda9c5a-bf'
        x1='230.75'
        x2='249.86'
        y1='81.77'
        y2='81.77'
        xlinkHref='#s-61bdda9c5a-a'
      />
      <radialGradient
        id='s-61bdda9c5a-bg'
        cx='234.17'
        cy='78.51'
        r='1.36'
        xlinkHref='#s-61bdda9c5a-b'
      />
      <linearGradient
        id='s-61bdda9c5a-bh'
        x1='243.05'
        x2='243.08'
        y1='299.13'
        y2='298.61'
        xlinkHref='#s-61bdda9c5a-c'
      />
      <linearGradient
        id='s-61bdda9c5a-d'
        x1='558.01'
        x2='566.03'
        y1='296.34'
        y2='295.21'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#525252'
        />
        <stop
          offset='.01'
          stopColor='#545454'
        />
        <stop
          offset='.23'
          stopColor='#818181'
        />
        <stop
          offset='.4'
          stopColor='#9e9e9e'
        />
        <stop
          offset='.5'
          stopColor='#a8a8a8'
        />
        <stop
          offset='.59'
          stopColor='#a2a2a2'
        />
        <stop
          offset='.72'
          stopColor='#909090'
        />
        <stop
          offset='.87'
          stopColor='#737373'
        />
        <stop
          offset='1'
          stopColor='#525252'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-bi'
        x1='566.86'
        x2='575.88'
        y1='296.61'
        y2='295.35'
        xlinkHref='#s-61bdda9c5a-d'
      />
      <linearGradient
        id='s-61bdda9c5a-e'
        x1='548.62'
        x2='548.96'
        y1='69.7'
        y2='69.7'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c2c2c2'
        />
        <stop
          offset='1'
          stopColor='#757575'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-bj'
        x1='549.38'
        x2='549.72'
        y1='69.73'
        y2='69.73'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bk'
        x1='550.11'
        x2='550.45'
        y1='69.76'
        y2='69.76'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bl'
        x1='550.87'
        x2='551.21'
        y1='69.82'
        y2='69.82'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bm'
        x1='551.61'
        x2='551.95'
        y1='69.89'
        y2='69.89'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bn'
        x1='552.37'
        x2='552.71'
        y1='69.92'
        y2='69.92'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bo'
        x1='553.1'
        x2='553.44'
        y1='69.96'
        y2='69.96'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bp'
        x1='553.86'
        x2='554.2'
        y1='70.01'
        y2='70.01'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bq'
        x1='554.58'
        x2='554.92'
        y1='70.04'
        y2='70.04'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-br'
        x1='555.34'
        x2='555.68'
        y1='70.08'
        y2='70.08'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bs'
        x1='556.07'
        x2='556.42'
        y1='70.11'
        y2='70.11'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bt'
        x1='556.83'
        x2='557.18'
        y1='70.16'
        y2='70.16'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bu'
        x1='557.57'
        x2='557.91'
        y1='70.24'
        y2='70.24'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bv'
        x1='558.33'
        x2='558.67'
        y1='70.27'
        y2='70.27'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bw'
        x1='559.06'
        x2='559.41'
        y1='70.31'
        y2='70.31'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bx'
        x1='559.82'
        x2='560.17'
        y1='70.36'
        y2='70.36'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-by'
        x1='560.61'
        x2='560.95'
        y1='70.41'
        y2='70.41'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bz'
        x1='561.37'
        x2='561.71'
        y1='70.44'
        y2='70.44'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bA'
        x1='562.1'
        x2='562.44'
        y1='70.48'
        y2='70.48'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bB'
        x1='562.86'
        x2='563.2'
        y1='70.53'
        y2='70.53'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bC'
        x1='563.6'
        x2='563.94'
        y1='70.6'
        y2='70.6'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bD'
        x1='564.36'
        x2='564.7'
        y1='70.63'
        y2='70.63'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bE'
        x1='565.09'
        x2='565.43'
        y1='70.67'
        y2='70.67'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bF'
        x1='565.85'
        x2='566.19'
        y1='70.72'
        y2='70.72'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bG'
        x1='566.57'
        x2='566.91'
        y1='70.76'
        y2='70.76'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bH'
        x1='567.33'
        x2='567.67'
        y1='70.79'
        y2='70.79'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bI'
        x1='568.06'
        x2='568.4'
        y1='70.82'
        y2='70.82'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bJ'
        x1='568.82'
        x2='569.16'
        y1='70.87'
        y2='70.87'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bK'
        x1='569.56'
        x2='569.9'
        y1='70.95'
        y2='70.95'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bL'
        x1='570.32'
        x2='570.66'
        y1='70.98'
        y2='70.98'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bM'
        x1='571.05'
        x2='571.39'
        y1='71.02'
        y2='71.02'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bN'
        x1='571.81'
        x2='572.15'
        y1='71.07'
        y2='71.07'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bO'
        x1='572.52'
        x2='572.86'
        y1='71.07'
        y2='71.07'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bP'
        x1='573.25'
        x2='573.59'
        y1='71.1'
        y2='71.1'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bQ'
        x1='574.01'
        x2='574.35'
        y1='71.15'
        y2='71.15'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bR'
        x1='574.75'
        x2='575.09'
        y1='71.23'
        y2='71.23'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bS'
        x1='575.51'
        x2='575.85'
        y1='71.26'
        y2='71.26'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bT'
        x1='576.24'
        x2='576.58'
        y1='71.3'
        y2='71.3'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bU'
        x1='577'
        x2='577.34'
        y1='71.35'
        y2='71.35'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bV'
        x1='550.67'
        x2='581.23'
        y1='283.13'
        y2='283.13'
        gradientTransform='rotate(86.78 565.953 283.133)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bW'
        x1='550.67'
        x2='581.23'
        y1='282.36'
        y2='282.36'
        gradientTransform='rotate(86.78 565.954 282.361)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bX'
        x1='550.67'
        x2='581.23'
        y1='284.68'
        y2='284.68'
        gradientTransform='rotate(86.78 565.951 284.678)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bY'
        x1='550.67'
        x2='581.23'
        y1='283.9'
        y2='283.9'
        gradientTransform='rotate(86.78 565.952 283.906)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-bZ'
        x1='550.67'
        x2='581.23'
        y1='286.31'
        y2='286.31'
        gradientTransform='rotate(86.78 565.952 286.31)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-ca'
        x1='550.67'
        x2='581.23'
        y1='285.54'
        y2='285.54'
        gradientTransform='rotate(86.78 565.953 285.538)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cb'
        x1='550.67'
        x2='581.23'
        y1='287.85'
        y2='287.85'
        gradientTransform='rotate(86.78 565.95 287.855)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cc'
        x1='550.67'
        x2='581.23'
        y1='287.08'
        y2='287.08'
        gradientTransform='rotate(86.78 565.95 287.082)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cd'
        x1='550.67'
        x2='581.23'
        y1='289.48'
        y2='289.48'
        gradientTransform='rotate(86.78 565.95 289.487)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-ce'
        x1='550.67'
        x2='581.23'
        y1='288.71'
        y2='288.71'
        gradientTransform='rotate(86.78 565.951 288.704)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cf'
        x1='550.67'
        x2='581.23'
        y1='291.03'
        y2='291.03'
        gradientTransform='rotate(86.78 565.953 291.026)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cg'
        x1='550.67'
        x2='581.23'
        y1='290.25'
        y2='290.25'
        gradientTransform='rotate(86.78 565.954 290.254)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-ch'
        x1='550.67'
        x2='581.23'
        y1='292.66'
        y2='292.66'
        gradientTransform='rotate(86.78 565.948 292.653)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-ci'
        x1='550.67'
        x2='581.23'
        y1='291.89'
        y2='291.89'
        gradientTransform='rotate(86.78 565.954 291.886)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cj'
        x1='550.67'
        x2='581.23'
        y1='293.43'
        y2='293.43'
        gradientTransform='rotate(86.78 565.947 293.425)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-ck'
        x1='550.67'
        x2='581.23'
        y1='295.06'
        y2='295.06'
        gradientTransform='rotate(86.78 565.953 295.063)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cl'
        x1='550.67'
        x2='581.23'
        y1='294.29'
        y2='294.29'
        gradientTransform='rotate(86.78 565.954 294.29)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cm'
        x1='550.67'
        x2='581.23'
        y1='296.61'
        y2='296.61'
        gradientTransform='rotate(86.78 565.95 296.607)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cn'
        x1='550.67'
        x2='581.23'
        y1='295.83'
        y2='295.83'
        gradientTransform='rotate(86.78 565.952 295.835)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-co'
        x1='550.67'
        x2='581.23'
        y1='298.24'
        y2='298.24'
        gradientTransform='rotate(86.78 565.95 298.24)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cp'
        x1='550.67'
        x2='581.23'
        y1='297.47'
        y2='297.47'
        gradientTransform='rotate(86.78 565.952 297.467)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-cq'
        x1='550.67'
        x2='581.23'
        y1='299.01'
        y2='299.01'
        gradientTransform='rotate(86.78 565.95 299.012)'
        xlinkHref='#s-61bdda9c5a-e'
      />
      <linearGradient
        id='s-61bdda9c5a-f'
        x1='565.95'
        x2='565.95'
        y1='300.89'
        y2='280.19'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.12'
          stopColor='#5b5b5b'
        />
        <stop
          offset='.35'
          stopColor='#6f6f6f'
        />
        <stop
          offset='.58'
          stopColor='#7c7c7c'
        />
        <stop
          offset='.81'
          stopColor='gray'
        />
        <stop
          offset='1'
          stopColor='#b3b3b3'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-cr'
        x1='565.48'
        x2='565.48'
        y1='297.63'
        y2='287.49'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-g'
        x1='1996.34'
        x2='1996.29'
        y1='731.42'
        y2='731.71'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#454545'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-cs'
        x1='746.45'
        x2='746.06'
        y1='1033.61'
        y2='1032.94'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        xlinkHref='#s-61bdda9c5a-g'
      />
      <radialGradient
        id='s-61bdda9c5a-m'
        cx='-1490.16'
        cy='537.8'
        r='4.63'
        gradientTransform='matrix(-1 .02 .03 .64 -944.07 -14.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#d1d1d1'
        />
        <stop
          offset='1'
          stopColor='#969696'
        />
      </radialGradient>
      <linearGradient
        id='s-61bdda9c5a-h'
        x1='137.69'
        x2='137.69'
        y1='145.85'
        y2='169.49'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='1'
          stopColor='#666'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-i'
        x1='111.91'
        x2='164.25'
        y1='156.8'
        y2='156.8'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#666'
        />
        <stop
          offset='1'
          stopColor='#999'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-ct'
        x1='159.09'
        x2='159.09'
        y1='366.64'
        y2='335.7'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cu'
        x1='160.2'
        x2='160.2'
        y1='366.78'
        y2='338.65'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cv'
        x1='161.29'
        x2='161.29'
        y1='366.92'
        y2='341.49'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cw'
        x1='162.37'
        x2='162.37'
        y1='367.06'
        y2='344.86'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cx'
        x1='163.46'
        x2='163.46'
        y1='367.19'
        y2='347.48'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cy'
        x1='164.57'
        x2='164.57'
        y1='367.32'
        y2='350.46'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cz'
        x1='157.71'
        x2='157.71'
        y1='366.54'
        y2='333.06'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cA'
        x1='155.21'
        x2='155.21'
        y1='368.05'
        y2='334.57'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cB'
        x1='152.71'
        x2='152.71'
        y1='369.44'
        y2='335.96'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cC'
        x1='150.21'
        x2='150.21'
        y1='371.04'
        y2='337.55'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cD'
        x1='147.49'
        x2='147.49'
        y1='372.65'
        y2='339.16'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cE'
        x1='145'
        x2='145'
        y1='374.15'
        y2='340.67'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cF'
        x1='142.5'
        x2='142.5'
        y1='375.55'
        y2='342.07'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cG'
        x1='140'
        x2='140'
        y1='377.14'
        y2='343.66'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cH'
        x1='137.58'
        x2='137.58'
        y1='378.71'
        y2='345.23'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cI'
        x1='135.08'
        x2='135.08'
        y1='380.22'
        y2='346.74'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cJ'
        x1='132.58'
        x2='132.58'
        y1='381.62'
        y2='348.13'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cK'
        x1='130.08'
        x2='130.08'
        y1='383.21'
        y2='349.73'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cL'
        x1='127.51'
        x2='127.51'
        y1='384.73'
        y2='351.24'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cM'
        x1='125.22'
        x2='125.22'
        y1='386.19'
        y2='352.71'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cN'
        x1='126.63'
        x2='126.63'
        y1='386.37'
        y2='355.43'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cO'
        x1='127.73'
        x2='127.73'
        y1='386.51'
        y2='358.38'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cP'
        x1='128.82'
        x2='128.82'
        y1='386.64'
        y2='361.22'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cQ'
        x1='129.91'
        x2='129.91'
        y1='386.78'
        y2='364.58'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cR'
        x1='130.99'
        x2='130.99'
        y1='386.92'
        y2='367.2'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cS'
        x1='132.1'
        x2='132.1'
        y1='387.05'
        y2='370.19'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cT'
        x1='164.95'
        x2='129.4'
        y1='140.53'
        y2='140.53'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-j'
        x1='147.92'
        x2='147.92'
        y1='169.49'
        y2='112.4'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='gray'
        />
        <stop
          offset='1'
          stopColor='#b3b3b3'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-cU'
        x1='160.64'
        x2='160.64'
        y1='329.76'
        y2='329.76'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-cV'
        x1='-1392.57'
        x2='-1392.57'
        y1='418.39'
        y2='448.95'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-cW'
        x1='-1405.56'
        x2='-1378.83'
        y1='432.39'
        y2='432.39'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-61bdda9c5a-i'
      />
      <linearGradient
        id='s-61bdda9c5a-cX'
        x1='-1407.3'
        x2='-1407.3'
        y1='298.24'
        y2='268.64'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cY'
        x1='-1406.46'
        x2='-1406.46'
        y1='298.38'
        y2='271.47'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-cZ'
        x1='-1405.56'
        x2='-1405.56'
        y1='298.51'
        y2='274.2'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-da'
        x1='-1404.69'
        x2='-1404.69'
        y1='298.65'
        y2='277.43'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-db'
        x1='-1403.79'
        x2='-1403.79'
        y1='298.78'
        y2='279.97'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dc'
        x1='-1402.85'
        x2='-1402.85'
        y1='298.9'
        y2='282.81'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dd'
        x1='-1408.33'
        x2='-1408.33'
        y1='297.97'
        y2='266.25'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-de'
        x1='-1409.35'
        x2='-1409.35'
        y1='300.14'
        y2='268.41'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-df'
        x1='-1410.34'
        x2='-1410.34'
        y1='302.18'
        y2='270.46'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dg'
        x1='-1411.45'
        x2='-1411.45'
        y1='304.75'
        y2='273.03'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dh'
        x1='-1412.39'
        x2='-1412.39'
        y1='306.57'
        y2='274.84'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-di'
        x1='-1413.39'
        x2='-1413.39'
        y1='308.7'
        y2='276.98'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dj'
        x1='-1414.39'
        x2='-1414.39'
        y1='310.84'
        y2='279.12'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dk'
        x1='-1415.5'
        x2='-1415.5'
        y1='313.43'
        y2='281.71'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dl'
        x1='-1416.55'
        x2='-1416.55'
        y1='315.69'
        y2='283.97'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dm'
        x1='-1417.58'
        x2='-1417.58'
        y1='317.98'
        y2='286.26'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dn'
        x1='-1418.62'
        x2='-1418.62'
        y1='320.27'
        y2='288.55'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-do'
        x1='-1419.51'
        x2='-1419.51'
        y1='321.69'
        y2='291.34'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dp'
        x1='-1420.33'
        x2='-1420.33'
        y1='323.3'
        y2='293.46'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dq'
        x1='-1420.86'
        x2='-1420.86'
        y1='324.32'
        y2='295.98'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dr'
        x1='-1420.01'
        x2='-1420.01'
        y1='324.63'
        y2='298.33'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-ds'
        x1='-1419.17'
        x2='-1419.17'
        y1='324.89'
        y2='301.16'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dt'
        x1='-1418.06'
        x2='-1418.06'
        y1='324.95'
        y2='303.88'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-du'
        x1='-1417.08'
        x2='-1417.08'
        y1='325.17'
        y2='307.11'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dv'
        x1='-1416.12'
        x2='-1416.12'
        y1='325.31'
        y2='309.66'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dw'
        x1='-1415.19'
        x2='-1415.19'
        y1='325.11'
        y2='312.49'
        gradientTransform='matrix(-1.01 -.11 -.11 .99 -420.1 -32.35)'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dx'
        x1='-1406.44'
        x2='-1417.92'
        y1='402.94'
        y2='402.94'
        gradientTransform='matrix(-1 .01 .01 1 -453.07 -195.99)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-dy'
        x1='-1411.47'
        x2='-1411.47'
        y1='434.18'
        y2='371.94'
        gradientTransform='matrix(-1 .01 .01 1 -453.07 -195.99)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-k'
        x1='549.24'
        x2='551.74'
        y1='132.5'
        y2='132.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#333'
        />
        <stop
          offset='.51'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#333'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-o'
        x1='507.19'
        x2='546.35'
        y1='152.07'
        y2='152.07'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#e6e6e6'
        />
        <stop
          offset='1'
          stopColor='#f2f2f2'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-dz'
        x1='498.57'
        x2='501.07'
        y1='200.35'
        y2='200.35'
        xlinkHref='#s-61bdda9c5a-k'
      />
      <linearGradient
        id='s-61bdda9c5a-dA'
        x1='138.22'
        x2='138.22'
        y1='144.93'
        y2='168.56'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-dB'
        x1='112.45'
        x2='164.78'
        y1='155.88'
        y2='155.88'
        xlinkHref='#s-61bdda9c5a-i'
      />
      <linearGradient
        id='s-61bdda9c5a-dC'
        x1='159.63'
        x2='159.63'
        y1='365.72'
        y2='334.78'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dD'
        x1='160.73'
        x2='160.73'
        y1='365.86'
        y2='337.73'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dE'
        x1='161.82'
        x2='161.82'
        y1='366'
        y2='340.57'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dF'
        x1='162.91'
        x2='162.91'
        y1='366.13'
        y2='343.93'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dG'
        x1='163.99'
        x2='163.99'
        y1='366.27'
        y2='346.55'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dH'
        x1='165.11'
        x2='165.11'
        y1='366.4'
        y2='349.54'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dI'
        x1='158.24'
        x2='158.24'
        y1='365.62'
        y2='332.13'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dJ'
        x1='155.75'
        x2='155.75'
        y1='367.13'
        y2='333.64'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dK'
        x1='153.25'
        x2='153.25'
        y1='368.52'
        y2='335.04'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dL'
        x1='150.75'
        x2='150.75'
        y1='370.12'
        y2='336.63'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dM'
        x1='148.03'
        x2='148.03'
        y1='371.72'
        y2='338.24'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dN'
        x1='145.53'
        x2='145.53'
        y1='373.23'
        y2='339.75'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dO'
        x1='143.03'
        x2='143.03'
        y1='374.63'
        y2='341.14'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dP'
        x1='140.54'
        x2='140.54'
        y1='376.22'
        y2='342.74'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dQ'
        x1='138.11'
        x2='138.11'
        y1='377.79'
        y2='344.31'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dR'
        x1='135.61'
        x2='135.61'
        y1='379.3'
        y2='345.82'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dS'
        x1='133.11'
        x2='133.11'
        y1='380.7'
        y2='347.21'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dT'
        x1='130.62'
        x2='130.62'
        y1='382.29'
        y2='348.81'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dU'
        x1='128.05'
        x2='128.05'
        y1='383.8'
        y2='350.32'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dV'
        x1='125.75'
        x2='125.75'
        y1='385.27'
        y2='351.78'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dW'
        x1='127.16'
        x2='127.16'
        y1='385.44'
        y2='354.51'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dX'
        x1='128.26'
        x2='128.26'
        y1='385.58'
        y2='357.46'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dY'
        x1='129.35'
        x2='129.35'
        y1='385.72'
        y2='360.3'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-dZ'
        x1='130.44'
        x2='130.44'
        y1='385.86'
        y2='363.66'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-ea'
        x1='131.52'
        x2='131.52'
        y1='386'
        y2='366.28'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-eb'
        x1='132.64'
        x2='132.64'
        y1='386.13'
        y2='369.27'
        xlinkHref='#s-61bdda9c5a-f'
      />
      <linearGradient
        id='s-61bdda9c5a-ec'
        x1='165.49'
        x2='129.93'
        y1='139.61'
        y2='139.61'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-ed'
        x1='148.45'
        x2='148.45'
        y1='168.56'
        y2='111.48'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ee'
        x1='161.17'
        x2='161.17'
        y1='328.83'
        y2='328.83'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-ef'
        x1='134.22'
        x2='143.8'
        y1='339.99'
        y2='339.99'
        gradientTransform='matrix(1.02 -.01 -.01 1.01 17.26 -232.22)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eg'
        x1='151.38'
        x2='159.7'
        y1='107.45'
        y2='107.45'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eh'
        x1='149.89'
        x2='158.69'
        y1='109.25'
        y2='109.25'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-ei'
        x1='158.68'
        x2='159.7'
        y1='99.52'
        y2='99.52'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-ej'
        x1='158.68'
        x2='159.7'
        y1='108.14'
        y2='108.14'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-l'
        x1='13.94'
        x2='14.93'
        y1='-355.63'
        y2='-355.63'
        gradientTransform='matrix(0 1 -2.47 0 -729.43 307.69)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.52'
          stopColor='#b3b3b3'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-ek'
        x1='21.33'
        x2='22.32'
        y1='-353.83'
        y2='-353.83'
        gradientTransform='matrix(0 1 -2.47 0 -724.98 308.93)'
        xlinkHref='#s-61bdda9c5a-l'
      />
      <linearGradient
        id='s-61bdda9c5a-el'
        x1='126.15'
        x2='135.73'
        y1='344.85'
        y2='344.85'
        gradientTransform='matrix(1.02 -.01 -.01 1.01 17.26 -232.22)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-em'
        x1='143.04'
        x2='151.37'
        y1='112.48'
        y2='112.48'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-en'
        x1='141.56'
        x2='150.36'
        y1='114.28'
        y2='114.28'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-eo'
        x1='150.34'
        x2='151.37'
        y1='104.55'
        y2='104.55'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-ep'
        x1='150.34'
        x2='151.37'
        y1='113.17'
        y2='113.17'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-eq'
        x1='150.54'
        x2='164.9'
        y1='318.85'
        y2='318.85'
        gradientTransform='rotate(31.2 157.722 318.898)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-er'
        x1='150.54'
        x2='164.9'
        y1='319.47'
        y2='319.47'
        gradientTransform='rotate(31.2 157.72 319.516)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-es'
        x1='150.54'
        x2='164.9'
        y1='320.11'
        y2='320.11'
        gradientTransform='rotate(31.2 157.724 320.152)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-et'
        x1='150.54'
        x2='164.9'
        y1='320.68'
        y2='320.68'
        gradientTransform='rotate(31.2 157.731 320.73)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eu'
        x1='150.54'
        x2='164.9'
        y1='321.3'
        y2='321.3'
        gradientTransform='rotate(31.2 157.73 321.347)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ev'
        x1='150.54'
        x2='164.9'
        y1='321.94'
        y2='321.94'
        gradientTransform='rotate(31.2 157.734 321.983)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ew'
        x1='150.54'
        x2='164.9'
        y1='322.52'
        y2='322.52'
        gradientTransform='rotate(31.2 157.722 322.566)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ex'
        x1='150.54'
        x2='164.9'
        y1='323.14'
        y2='323.14'
        gradientTransform='rotate(31.2 157.721 323.184)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ey'
        x1='150.54'
        x2='164.9'
        y1='323.78'
        y2='323.78'
        gradientTransform='rotate(31.2 157.725 323.82)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ez'
        x1='150.54'
        x2='164.9'
        y1='324.35'
        y2='324.35'
        gradientTransform='rotate(31.2 157.732 324.397)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eA'
        x1='150.54'
        x2='164.9'
        y1='324.97'
        y2='324.97'
        gradientTransform='rotate(31.2 157.73 325.015)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eB'
        x1='150.54'
        x2='164.9'
        y1='325.61'
        y2='325.61'
        gradientTransform='rotate(31.2 157.735 325.65)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eC'
        x1='150.54'
        x2='164.9'
        y1='326.23'
        y2='326.23'
        gradientTransform='rotate(31.2 157.715 326.274)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eD'
        x1='150.54'
        x2='164.9'
        y1='326.85'
        y2='326.85'
        gradientTransform='rotate(31.2 157.732 326.887)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eE'
        x1='150.54'
        x2='164.9'
        y1='327.49'
        y2='327.49'
        gradientTransform='rotate(31.2 157.718 327.528)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eF'
        x1='150.54'
        x2='164.9'
        y1='328.06'
        y2='328.06'
        gradientTransform='rotate(31.2 157.725 328.105)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eG'
        x1='150.54'
        x2='164.9'
        y1='328.67'
        y2='328.67'
        gradientTransform='rotate(31.2 157.724 328.723)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eH'
        x1='150.54'
        x2='164.9'
        y1='329.32'
        y2='329.32'
        gradientTransform='rotate(31.2 157.728 329.36)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eI'
        x1='150.54'
        x2='164.9'
        y1='329.9'
        y2='329.9'
        gradientTransform='rotate(31.2 157.716 329.941)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eJ'
        x1='150.54'
        x2='164.9'
        y1='330.52'
        y2='330.52'
        gradientTransform='rotate(31.2 157.733 330.555)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eK'
        x1='150.54'
        x2='164.9'
        y1='331.16'
        y2='331.16'
        gradientTransform='rotate(31.2 157.719 331.195)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eL'
        x1='150.54'
        x2='164.9'
        y1='331.73'
        y2='331.73'
        gradientTransform='rotate(31.2 157.726 331.773)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eM'
        x1='150.54'
        x2='164.9'
        y1='332.34'
        y2='332.34'
        gradientTransform='rotate(31.2 157.725 332.39)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eN'
        x1='148.39'
        x2='148.39'
        y1='116.83'
        y2='101.76'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eO'
        x1='148.86'
        x2='148.86'
        y1='116.55'
        y2='101.47'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eP'
        x1='149.32'
        x2='149.32'
        y1='116.28'
        y2='101.21'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eQ'
        x1='149.78'
        x2='149.78'
        y1='115.99'
        y2='100.92'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eR'
        x1='150.22'
        x2='150.22'
        y1='115.76'
        y2='100.68'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eS'
        x1='150.69'
        x2='150.69'
        y1='115.47'
        y2='100.4'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eT'
        x1='151.15'
        x2='151.15'
        y1='115.2'
        y2='100.13'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eU'
        x1='151.61'
        x2='151.61'
        y1='114.92'
        y2='99.84'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eV'
        x1='152.08'
        x2='152.08'
        y1='114.62'
        y2='99.55'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eW'
        x1='152.54'
        x2='152.54'
        y1='114.34'
        y2='99.26'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eX'
        x1='153'
        x2='153'
        y1='114.07'
        y2='99'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eY'
        x1='153.47'
        x2='153.47'
        y1='113.78'
        y2='98.71'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-eZ'
        x1='153.91'
        x2='153.91'
        y1='113.55'
        y2='98.47'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fa'
        x1='154.37'
        x2='154.37'
        y1='113.26'
        y2='98.19'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fb'
        x1='154.83'
        x2='154.83'
        y1='112.99'
        y2='97.92'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fc'
        x1='155.3'
        x2='155.3'
        y1='112.71'
        y2='97.64'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fd'
        x1='155.76'
        x2='155.76'
        y1='112.43'
        y2='97.36'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fe'
        x1='156.22'
        x2='156.22'
        y1='112.15'
        y2='97.07'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ff'
        x1='156.68'
        x2='156.68'
        y1='111.88'
        y2='96.81'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fg'
        x1='157.14'
        x2='157.14'
        y1='111.59'
        y2='96.52'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fh'
        x1='157.59'
        x2='157.59'
        y1='111.36'
        y2='96.28'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fi'
        x1='158.05'
        x2='158.05'
        y1='111.07'
        y2='96'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fj'
        x1='158.51'
        x2='158.51'
        y1='110.8'
        y2='95.73'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fk'
        x1='158.97'
        x2='158.97'
        y1='110.52'
        y2='95.45'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fl'
        x1='159.41'
        x2='159.41'
        y1='110.19'
        y2='95.12'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fm'
        x1='159.87'
        x2='159.87'
        y1='109.9'
        y2='94.83'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fn'
        x1='160.33'
        x2='160.33'
        y1='109.64'
        y2='94.56'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fo'
        x1='160.79'
        x2='160.79'
        y1='109.35'
        y2='94.28'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fp'
        x1='161.24'
        x2='161.24'
        y1='109.11'
        y2='94.04'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fq'
        x1='161.7'
        x2='161.7'
        y1='108.83'
        y2='93.75'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-n'
        x1='150.34'
        x2='165.1'
        y1='325.5'
        y2='325.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='1'
          stopColor='gray'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-fr'
        x1='154.18'
        x2='161.34'
        y1='327.39'
        y2='327.39'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fs'
        x1='-1534.08'
        x2='-1534.12'
        y1='331.23'
        y2='331.48'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        xlinkHref='#s-61bdda9c5a-g'
      />
      <linearGradient
        id='s-61bdda9c5a-ft'
        x1='-1530.62'
        x2='-1530.92'
        y1='333.74'
        y2='333.23'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        xlinkHref='#s-61bdda9c5a-g'
      />
      <radialGradient
        id='s-61bdda9c5a-fu'
        cx='-1534.79'
        cy='332.73'
        r='3.4'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        xlinkHref='#s-61bdda9c5a-m'
      />
      <linearGradient
        id='s-61bdda9c5a-fv'
        x1='-1236.62'
        x2='-1227.66'
        y1='378.88'
        y2='378.88'
        gradientTransform='matrix(-1.02 -.01 .01 1.01 -310.63 -232.22)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fw'
        x1='-1251.02'
        x2='-1243.68'
        y1='387.11'
        y2='387.11'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fx'
        x1='-1252.45'
        x2='-1243.98'
        y1='388.79'
        y2='388.79'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fy'
        x1='-1244.01'
        x2='-1243.25'
        y1='378.81'
        y2='378.81'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fz'
        x1='-1244.02'
        x2='-1243.68'
        y1='387.26'
        y2='387.26'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fA'
        x1='-1363.5'
        x2='-1362.55'
        y1='71.67'
        y2='71.67'
        gradientTransform='matrix(-1 0 0 1.83 -397.76 260.03)'
        xlinkHref='#s-61bdda9c5a-l'
      />
      <linearGradient
        id='s-61bdda9c5a-fB'
        x1='-1373.67'
        x2='-1372.72'
        y1='77.41'
        y2='77.41'
        gradientTransform='matrix(-1 0 0 1.82 -407.93 242.41)'
        xlinkHref='#s-61bdda9c5a-l'
      />
      <linearGradient
        id='s-61bdda9c5a-fC'
        x1='-1238.68'
        x2='-1229.72'
        y1='385.35'
        y2='385.35'
        gradientTransform='matrix(-1.02 -.01 .01 1.01 -310.63 -232.22)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fD'
        x1='-1253.23'
        x2='-1245.88'
        y1='393.67'
        y2='393.67'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fE'
        x1='-1254.65'
        x2='-1246.19'
        y1='395.35'
        y2='395.35'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fF'
        x1='-1246.22'
        x2='-1245.45'
        y1='385.36'
        y2='385.36'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fG'
        x1='-1246.22'
        x2='-1245.88'
        y1='393.82'
        y2='393.82'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-fH'
        x1='-1246.11'
        x2='-1243.23'
        y1='379.97'
        y2='379.97'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fI'
        x1='-1246.11'
        x2='-1243.23'
        y1='380.56'
        y2='380.56'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fJ'
        x1='-1246.11'
        x2='-1243.23'
        y1='381.18'
        y2='381.18'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fK'
        x1='-1246.11'
        x2='-1243.23'
        y1='381.73'
        y2='381.73'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fL'
        x1='-1246.11'
        x2='-1243.23'
        y1='382.32'
        y2='382.32'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fM'
        x1='-1246.11'
        x2='-1243.23'
        y1='382.93'
        y2='382.93'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fN'
        x1='-1246.11'
        x2='-1243.23'
        y1='383.49'
        y2='383.49'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fO'
        x1='-1246.11'
        x2='-1243.23'
        y1='384.08'
        y2='384.08'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fP'
        x1='-1246.11'
        x2='-1243.23'
        y1='384.7'
        y2='384.7'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fQ'
        x1='-1246.11'
        x2='-1243.23'
        y1='385.25'
        y2='385.25'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fR'
        x1='-1246.11'
        x2='-1243.23'
        y1='385.84'
        y2='385.84'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fS'
        x1='-1246.11'
        x2='-1243.23'
        y1='386.45'
        y2='386.45'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fT'
        x1='-1246.11'
        x2='-1243.23'
        y1='387.05'
        y2='387.05'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fU'
        x1='-1246.11'
        x2='-1243.23'
        y1='387.64'
        y2='387.64'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fV'
        x1='-1246.11'
        x2='-1243.23'
        y1='388.26'
        y2='388.26'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fW'
        x1='-1246.11'
        x2='-1243.23'
        y1='388.81'
        y2='388.81'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fX'
        x1='-1246.11'
        x2='-1243.23'
        y1='389.4'
        y2='389.4'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fY'
        x1='-1246.11'
        x2='-1243.23'
        y1='390.01'
        y2='390.01'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-fZ'
        x1='-1246.11'
        x2='-1243.23'
        y1='390.58'
        y2='390.58'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ga'
        x1='-1246.11'
        x2='-1243.23'
        y1='391.17'
        y2='391.17'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gb'
        x1='-1246.11'
        x2='-1243.23'
        y1='391.78'
        y2='391.78'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gc'
        x1='-1246.11'
        x2='-1243.23'
        y1='392.33'
        y2='392.33'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gd'
        x1='-1246.11'
        x2='-1243.23'
        y1='392.92'
        y2='392.92'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-ge'
        x1='-1245.94'
        x2='-1245.94'
        y1='397.3'
        y2='382.84'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gf'
        x1='-1245.85'
        x2='-1245.85'
        y1='397.03'
        y2='382.56'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gg'
        x1='-1245.76'
        x2='-1245.76'
        y1='396.77'
        y2='382.31'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gh'
        x1='-1245.66'
        x2='-1245.66'
        y1='396.5'
        y2='382.03'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gi'
        x1='-1245.58'
        x2='-1245.58'
        y1='396.27'
        y2='381.8'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gj'
        x1='-1245.48'
        x2='-1245.48'
        y1='396'
        y2='381.53'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gk'
        x1='-1245.39'
        x2='-1245.39'
        y1='395.74'
        y2='381.27'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gl'
        x1='-1245.3'
        x2='-1245.3'
        y1='395.47'
        y2='381'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gm'
        x1='-1245.21'
        x2='-1245.21'
        y1='395.18'
        y2='380.72'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gn'
        x1='-1245.11'
        x2='-1245.11'
        y1='394.91'
        y2='380.44'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-go'
        x1='-1245.02'
        x2='-1245.02'
        y1='394.65'
        y2='380.18'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gp'
        x1='-1244.93'
        x2='-1244.93'
        y1='394.38'
        y2='379.91'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gq'
        x1='-1244.84'
        x2='-1244.84'
        y1='394.15'
        y2='379.68'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gr'
        x1='-1244.75'
        x2='-1244.75'
        y1='393.88'
        y2='379.41'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gs'
        x1='-1244.66'
        x2='-1244.66'
        y1='393.62'
        y2='379.15'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gt'
        x1='-1244.57'
        x2='-1244.57'
        y1='393.35'
        y2='378.88'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gu'
        x1='-1244.48'
        x2='-1244.48'
        y1='393.08'
        y2='378.61'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gv'
        x1='-1244.38'
        x2='-1244.38'
        y1='392.81'
        y2='378.34'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gw'
        x1='-1244.29'
        x2='-1244.29'
        y1='392.55'
        y2='378.08'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gx'
        x1='-1244.2'
        x2='-1244.2'
        y1='392.28'
        y2='377.81'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gy'
        x1='-1244.11'
        x2='-1244.11'
        y1='392.05'
        y2='377.58'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gz'
        x1='-1244.02'
        x2='-1244.02'
        y1='391.78'
        y2='377.31'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gA'
        x1='-1243.93'
        x2='-1243.93'
        y1='391.52'
        y2='377.05'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gB'
        x1='-1243.84'
        x2='-1243.84'
        y1='391.25'
        y2='376.78'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gC'
        x1='-1243.75'
        x2='-1243.75'
        y1='390.93'
        y2='376.46'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gD'
        x1='-1243.66'
        x2='-1243.66'
        y1='390.65'
        y2='376.19'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gE'
        x1='-1243.57'
        x2='-1243.57'
        y1='390.4'
        y2='375.93'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gF'
        x1='-1243.48'
        x2='-1243.48'
        y1='390.12'
        y2='375.65'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gG'
        x1='-1243.39'
        x2='-1243.39'
        y1='389.9'
        y2='375.43'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gH'
        x1='-1243.3'
        x2='-1243.3'
        y1='389.62'
        y2='375.15'
        gradientTransform='matrix(-1 0 0 1 -290.45 -220.08)'
        xlinkHref='#s-61bdda9c5a-j'
      />
      <linearGradient
        id='s-61bdda9c5a-gI'
        x1='-1246.2'
        x2='-1243.13'
        y1='386.35'
        y2='386.35'
        gradientTransform='matrix(-1 0 0 1 -287.53 0)'
        xlinkHref='#s-61bdda9c5a-n'
      />
      <linearGradient
        id='s-61bdda9c5a-gJ'
        x1='-1245.54'
        x2='-1243.78'
        y1='388.17'
        y2='388.17'
        gradientTransform='matrix(-1 0 0 1 -287.53 0)'
        xlinkHref='#s-61bdda9c5a-h'
      />
      <linearGradient
        id='s-61bdda9c5a-gK'
        x1='-132.5'
        x2='-132.55'
        y1='390.14'
        y2='390.38'
        gradientTransform='translate(1084.8)'
        xlinkHref='#s-61bdda9c5a-g'
      />
      <linearGradient
        id='s-61bdda9c5a-gL'
        x1='-129.19'
        x2='-129.47'
        y1='392.55'
        y2='392.06'
        gradientTransform='translate(1084.8)'
        xlinkHref='#s-61bdda9c5a-g'
      />
      <radialGradient
        id='s-61bdda9c5a-gM'
        cx='-133.19'
        cy='391.57'
        r='3.26'
        gradientTransform='translate(1084.8)'
        xlinkHref='#s-61bdda9c5a-m'
      />
      <linearGradient
        id='s-61bdda9c5a-gN'
        x1='549.49'
        x2='551.49'
        y1='132.5'
        y2='132.5'
        xlinkHref='#s-61bdda9c5a-k'
      />
      <linearGradient
        id='s-61bdda9c5a-gO'
        x1='498.82'
        x2='500.82'
        y1='200.35'
        y2='200.35'
        xlinkHref='#s-61bdda9c5a-k'
      />
      <linearGradient
        id='s-61bdda9c5a-gP'
        x1='495.48'
        x2='496.48'
        y1='217.16'
        y2='217.16'
        xlinkHref='#s-61bdda9c5a-o'
      />
      <linearGradient
        id='s-61bdda9c5a-gQ'
        x1='552.59'
        x2='553.59'
        y1='132.79'
        y2='132.79'
        xlinkHref='#s-61bdda9c5a-o'
      />
      <linearGradient
        id='s-61bdda9c5a-gR'
        x1='489.58'
        x2='558.12'
        y1='176.46'
        y2='176.46'
        xlinkHref='#s-61bdda9c5a-o'
      />
      <linearGradient
        id='s-61bdda9c5a-gS'
        x1='488.83'
        x2='491.33'
        y1='227.41'
        y2='227.41'
        xlinkHref='#s-61bdda9c5a-k'
      />
      <linearGradient
        id='s-61bdda9c5a-gT'
        x1='556.37'
        x2='558.87'
        y1='127.89'
        y2='127.89'
        xlinkHref='#s-61bdda9c5a-k'
      />
      <linearGradient
        id='s-61bdda9c5a-p'
        x1='189.07'
        x2='189.07'
        y1='372.15'
        y2='386.87'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-61bdda9c5a-gU'
        x1='172.88'
        x2='205.75'
        y1='378.93'
        y2='378.93'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-gV'
        x1='194.61'
        x2='205.57'
        y1='361.93'
        y2='361.93'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-gW'
        x1='173.77'
        x2='184.73'
        y1='374.26'
        y2='374.26'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-gX'
        x1='183.86'
        x2='206.18'
        y1='368.7'
        y2='368.7'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-gY'
        x1='184.79'
        x2='206.19'
        y1='369.1'
        y2='369.1'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-gZ'
        x1='-1341.62'
        x2='-1341.62'
        y1='418.59'
        y2='439.05'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-ha'
        x1='-1349.75'
        x2='-1333.05'
        y1='428.08'
        y2='428.08'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-hb'
        x1='913.79'
        x2='924.23'
        y1='409.04'
        y2='409.04'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-hc'
        x1='920.31'
        x2='930.47'
        y1='427.65'
        y2='427.65'
        xlinkHref='#s-61bdda9c5a-p'
      />
      <linearGradient
        id='s-61bdda9c5a-hd'
        x1='913.63'
        x2='920.63'
        y1='418.8'
        y2='418.8'
        xlinkHref='#s-61bdda9c5a-p'
      />
    </defs>
    <g
      id='surface'
    >
      <g
        id='mainSurface'
      >
        <path
          d='M1015.65 310.89L1.6 228.7 217.27 99.97l740.23 41.74 58.15 169.18z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M989.58 296.39l-951-73 191-114 711 40 49 147z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M478.81 257.18l86.85-128.88'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <path
        id='surfaceTennis'
        className='tennisLines'
        d='M818.69 255.71l-604.83-44.38 105.51-79.22 496.91 29.81 2.41 93.79z'
      />
      <path
        id='surfaceVolleyball'
        className='volleyballLines'
        d='M740.42 231.88l-437.87-31.25 62.33-53.92 384.2 23.98-8.66 61.19z'
      />
      <path
        id='surfaceBadminton'
        className='volleyballLines'
        d='M688.42 228.17l-341.51-24.36 57.62-54.47 298.93 18.51-15.04 60.32z'
      />
      <g
        id='surfaceBasket'
        className='basketballTwo'
      >
        <path
          d='M232.04 176.21l-104.27-6.05 38.94-23.25 96.37 6.1-31.04 23.2zM966.68 227.2l-127.33-8.61v-28.08l117.34 6.72 9.99 29.97z'
        />
      </g>
      <path
        id='surfaceBasketAcross'
        className='basketballOne'
        d='M588.95 160.65L505 156.41l23.83-30.18 76.64 4.31-16.52 30.11z'
      />
    </g>
    <g
      id='lines'
    >
      <g
        className='tennisLines'
      >
        <path
          d='M818.69 255.71l-604.83-44.38 105.51-79.22 496.91 29.81 2.41 93.79zM312.13 137.55l504.31 30.87M224 203.72l594.45 42.85M338.54 211.98l71.94-68.41M501.58 223.39l48.21-71.35M705.02 161.6l-18.79 75.44M380.83 171.74l316.44 20.97'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='basketballLines'
        className='basketballTwo'
      >
        <ellipse
          cx='253.79'
          cy='384.74'
          rx='38.68'
          ry='11.48'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-4.71 -2423.24 310.39)'
        />
        <path
          d='M232.04 176.21l-104.27-6.05 38.94-23.25 96.37 6.1-31.04 23.2z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M207.54 344.36c40.9-2.84 117.63 16.39 83 41.12-58.54 41.76-175.36 37.94-208.45 33.76'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <ellipse
          cx='839.34'
          cy='424.42'
          rx='14'
          ry='40.9'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-86 717.524 315.157)'
        />
        <path
          d='M950.49 389.93c-104.72-6.73-153.3 12.22-152.82 31.88.62 25.47 59.25 55.94 184.88 64.31'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M966.68 227.2l-127.33-8.61v-28.08l117.34 6.72 9.99 29.97z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        className='volleyballLines'
      >
        <path
          d='M740.42 231.88l-437.87-31.25 62.33-53.92 384.2 23.98-8.66 61.19zM438.62 210.35l46.67-56.68M506.97 215.22l38.88-57.44M584.62 220.76l28.02-58.58'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        className='badminton'
      >
        <path
          d='M688.42 228.17l-341.51-24.36 57.62-54.47 298.93 18.51-15.04 60.32zM501.58 223.39l50-74M380.83 171.74l106.08 7.34M576.83 184.84l120.44 7.87M558.66 218.92l31.99-58.49M461.26 211.97l44.37-56.88M688.17 166.9l-18.03 59.97M363.13 204.97l56.29-54.73M351.59 199.38l338.16 23.48M401.62 152.29l301.11 18.5'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='footballLines'
        className='football'
      >
        <path
          d='M207.54 344.36c40.9-2.84 117.63 16.39 83 41.12-58.54 41.76-175.36 37.94-208.45 33.76M950.49 389.93c-104.72-6.73-153.3 12.22-152.82 31.88.62 25.47 59.25 55.94 184.88 64.31'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
      <g
        id='basketballAcrossLines'
        className='basketballOne'
      >
        <path
          d='M455.64 342.19C394.2 400.37 688.92 414.41 699 355.88'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M588.95 160.65L505 156.41l23.83-30.18 76.64 4.31-16.52 30.11z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M591.87 380.73c-5.72 7.14-21.21 12.2-41.71 11.87-23.34-.38-45.9-5.87-42.27-16.39'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
    </g>
    <image
      id='high'
      width='4183'
      height='1282'
      transform='translate(12.92) scale(.24)'
      xlinkHref={_36x181}
    />
    <image
      id='medium'
      width='4058'
      height='1115'
      transform='matrix(.24 0 0 .24 32.84 16.32)'
      xlinkHref={_36x182}
    />
    <image
      id='small'
      width='4104'
      height='1064'
      transform='matrix(.24 0 0 .24 22.28 29.28)'
      xlinkHref={_36x183}
    />
    <image
      id='arena'
      width='4004'
      height='867'
      transform='matrix(.24 0 0 .24 42.44 67.92)'
      xlinkHref={_36x184}
    />
    <g
      id='wicketArena'
    >
      <path
        d='M265.56 100.63l-23.78-1.42V69.33l23.78 1.31v29.99z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M263.51 77.87l1.31.05v-1.68l-1.31-.09v1.72zM263.51 95.47l1.31.05v-1.67l-1.31-.09v1.71zM242.63 77.11l1.1.05v-1.67l-1.1-.09v1.71zM242.63 94.71l1.1.05v-1.67l-1.1-.09v1.71z'
        style={{
          fill: '#9e9e9e',
        }}
      />
      <path
        d='M241.78 70.31v30.57'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-61bdda9c5a-a)',
        }}
      />
      <path
        d='M254.83 71.53v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-q)',
        }}
      />
      <path
        d='M253.65 71.44v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-r)',
        }}
      />
      <path
        d='M252.54 71.37v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-s)',
        }}
      />
      <path
        d='M251.43 71.31v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-t)',
        }}
      />
      <path
        d='M250.24 71.22v28.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-u)',
        }}
      />
      <path
        d='M249.13 71.15v28.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-v)',
        }}
      />
      <path
        d='M248.06 71.05v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-w)',
        }}
      />
      <path
        d='M246.88 70.96v28.15'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-x)',
        }}
      />
      <path
        d='M262.73 72.01v28.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-y)',
        }}
      />
      <path
        d='M261.62 71.94v28.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-z)',
        }}
      />
      <path
        d='M260.52 71.88v28.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-A)',
        }}
      />
      <path
        d='M259.33 71.8v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-B)',
        }}
      />
      <path
        d='M258.22 71.73v28.28'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-C)',
        }}
      />
      <path
        d='M257.15 71.62V99.9'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-D)',
        }}
      />
      <path
        d='M255.96 71.53v28.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-E)',
        }}
      />
      <path
        d='M245.77 70.91v28.15'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-F)',
        }}
      />
      <path
        d='M244.66 70.91v28.01'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-G)',
        }}
      />
      <path
        d='M263.37 74.15l-19.74-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-H)',
        }}
      />
      <path
        d='M263.37 73.16l-19.64-1.06'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-I)',
        }}
      />
      <path
        d='M263.33 72.37l-19.6-1.14'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-J)',
        }}
      />
      <path
        d='M263.37 75.05l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-K)',
        }}
      />
      <path
        d='M263.37 75.89l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-L)',
        }}
      />
      <path
        d='M263.37 76.72l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-M)',
        }}
      />
      <path
        d='M263.37 77.6l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-N)',
        }}
      />
      <path
        d='M263.37 78.5l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-O)',
        }}
      />
      <path
        d='M263.37 79.34l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-P)',
        }}
      />
      <path
        d='M263.37 80.17l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-Q)',
        }}
      />
      <path
        d='M263.37 81.08l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-R)',
        }}
      />
      <path
        d='M263.37 81.98l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-S)',
        }}
      />
      <path
        d='M263.37 82.82l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-T)',
        }}
      />
      <path
        d='M263.37 83.65l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-U)',
        }}
      />
      <path
        d='M263.37 84.53l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-V)',
        }}
      />
      <path
        d='M263.37 85.43l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-W)',
        }}
      />
      <path
        d='M263.37 86.27l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-X)',
        }}
      />
      <path
        d='M263.37 87.1l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-Y)',
        }}
      />
      <path
        d='M263.37 87.95l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-Z)',
        }}
      />
      <path
        d='M263.37 88.85l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aa)',
        }}
      />
      <path
        d='M263.37 89.69l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ab)',
        }}
      />
      <path
        d='M263.37 90.52l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ac)',
        }}
      />
      <path
        d='M263.37 91.4l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ad)',
        }}
      />
      <path
        d='M263.37 92.3l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ae)',
        }}
      />
      <path
        d='M263.37 93.14l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-af)',
        }}
      />
      <path
        d='M263.37 93.98l-19.74-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ag)',
        }}
      />
      <path
        d='M263.37 94.88l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ah)',
        }}
      />
      <path
        d='M263.37 95.78l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ai)',
        }}
      />
      <path
        d='M263.37 96.62l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aj)',
        }}
      />
      <path
        d='M263.37 97.46l-19.74-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ak)',
        }}
      />
      <path
        d='M263.37 98.33l-19.74-.92'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-al)',
        }}
      />
      <path
        d='M263.37 99.2l-19.74-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-am)',
        }}
      />
      <path
        d='M246.89 291l19.25 1.13v27.9l-19.25-1.14V291m-.5-.53v28.9l20.25 1.19v-28.9l-20.25-1.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-an)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M265.56 71.64v30.57'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-61bdda9c5a-ao)',
        }}
      />
      <circle
        cx='246.79'
        cy='85.08'
        r='1.36'
        style={{
          fill: 'url(#s-61bdda9c5a-b)',
        }}
      />
      <path
        d='M246.79 85.08l3.45.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-61bdda9c5a-c)',
        }}
      />
    </g>
    <g
      id='wicket'
    >
      <path
        d='M249.36 101.56l-18.11-1.03V62.09l18.11 1.06v38.41z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M249.13 73.27l-.85-.07v-3.37l.85.07v3.37zM249.13 94.56l-.85-.07v-3.37l.85.07v3.37z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M248.28 64.63v36.32'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ap)',
        }}
      />
      <path
        d='M247.09 64.56v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aq)',
        }}
      />
      <path
        d='M245.98 64.5v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ar)',
        }}
      />
      <path
        d='M244.87 64.39v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-as)',
        }}
      />
      <path
        d='M243.68 64.32v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-at)',
        }}
      />
      <path
        d='M242.57 64.25v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-au)',
        }}
      />
      <path
        d='M241.45 64.19v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-av)',
        }}
      />
      <path
        d='M240.26 64.11v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aw)',
        }}
      />
      <path
        d='M239.15 64.05v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ax)',
        }}
      />
      <path
        d='M238.04 63.98v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ay)',
        }}
      />
      <path
        d='M236.85 63.98v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-az)',
        }}
      />
      <path
        d='M235.74 63.84v36.39'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aA)',
        }}
      />
      <path
        d='M234.66 63.8v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aB)',
        }}
      />
      <path
        d='M233.47 63.74v36.39'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aC)',
        }}
      />
      <path
        d='M232.36 63.66v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aD)',
        }}
      />
      <path
        d='M248.28 70.23l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aE)',
        }}
      />
      <path
        d='M248.28 68.78l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aF)',
        }}
      />
      <path
        d='M248.28 67.4l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aG)',
        }}
      />
      <path
        d='M248.28 65.95l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aH)',
        }}
      />
      <path
        d='M248.28 64.57l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aI)',
        }}
      />
      <path
        d='M248.28 99.85l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aJ)',
        }}
      />
      <path
        d='M248.28 101.06l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aK)',
        }}
      />
      <path
        d='M248.28 98.47l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aL)',
        }}
      />
      <path
        d='M248.28 97.02l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aM)',
        }}
      />
      <path
        d='M248.28 95.64l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aN)',
        }}
      />
      <path
        d='M248.28 94.19l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aO)',
        }}
      />
      <path
        d='M248.28 92.82l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aP)',
        }}
      />
      <path
        d='M248.28 91.36l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aQ)',
        }}
      />
      <path
        d='M248.28 89.99l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aR)',
        }}
      />
      <path
        d='M248.28 88.53l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aS)',
        }}
      />
      <path
        d='M248.28 87.12l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aT)',
        }}
      />
      <path
        d='M248.28 85.67l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aU)',
        }}
      />
      <path
        d='M248.28 84.29l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aV)',
        }}
      />
      <path
        d='M248.28 82.84l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aW)',
        }}
      />
      <path
        d='M248.28 81.46l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aX)',
        }}
      />
      <path
        d='M248.28 80.01l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aY)',
        }}
      />
      <path
        d='M248.28 78.63l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-aZ)',
        }}
      />
      <path
        d='M248.28 77.18l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-ba)',
        }}
      />
      <path
        d='M248.28 75.8l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-bb)',
        }}
      />
      <path
        d='M248.28 74.35l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-bc)',
        }}
      />
      <path
        d='M248.28 72.97l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-bd)',
        }}
      />
      <path
        d='M248.28 71.52l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-61bdda9c5a-be)',
        }}
      />
      <path
        d='M231.25 100.34V62.15l18.11 1.05v38.18'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-bf)',
        }}
      />
      <circle
        cx='234.17'
        cy='78.51'
        r='1.36'
        style={{
          fill: 'url(#s-61bdda9c5a-bg)',
        }}
      />
      <path
        d='M234.17 78.51l3.45.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-61bdda9c5a-bh)',
        }}
      />
    </g>
    <g
      id='basketballAcross'
      className='basketballOne'    
      >
      <path
        d='M567.09 305.58a.35.35 0 0 1-.3-.18l-10.14-18.93a.34.34 0 0 1 .6-.32l10.15 18.92a.35.35 0 0 1-.14.47.47.47 0 0 1-.17.04z'
        style={{
          fill: 'url(#s-61bdda9c5a-d)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M566.55 129.06l-2.69-.14V74.71l2.69-.01v54.36z'
        style={{
          fill: '#a6a6a6',
        }}
      />
      <path
        d='M566.55 129.06l1.05-.59V74.36l-1.05.34v54.36z'
        style={{
          fill: '#6f6f73',
        }}
      />
      <path
        d='M567.6 74.36l-1.05.34-2.69.01 1.87-.42 1.87.07z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M566.28 91.17h-2.04L561 76.81h2.03l3.25 14.36z'
        style={{
          fill: '#969696',
        }}
      />
      <path
        d='M566.28 86.5v4.67l-3.24-14.36H561l.98-1.01h1.88l2.42 10.7z'
        style={{
          fill: '#6f6f73',
        }}
      />
      <path
        d='M568.41 305.52h-.1a.34.34 0 0 1-.22-.43l5.91-18.41a.34.34 0 0 1 .43-.22.34.34 0 0 1 .22.43l-5.92 18.39a.34.34 0 0 1-.32.24z'
        style={{
          fill: 'url(#s-61bdda9c5a-bi)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M548.62 60.54h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-e)',
        }}
      />
      <path
        d='M549.38 60.58h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bj)',
        }}
      />
      <path
        d='M550.11 60.61h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bk)',
        }}
      />
      <path
        d='M550.87 60.66h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bl)',
        }}
      />
      <path
        d='M551.61 60.74h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bm)',
        }}
      />
      <path
        d='M552.37 60.77h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bn)',
        }}
      />
      <path
        d='M553.1 60.8h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bo)',
        }}
      />
      <path
        d='M553.86 60.86h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bp)',
        }}
      />
      <path
        d='M554.58 60.89h.34V79.2h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bq)',
        }}
      />
      <path
        d='M555.34 60.92h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-br)',
        }}
      />
      <path
        d='M556.07 60.96h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bs)',
        }}
      />
      <path
        d='M556.83 61.01h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bt)',
        }}
      />
      <path
        d='M557.57 61.08h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bu)',
        }}
      />
      <path
        d='M558.33 61.12h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bv)',
        }}
      />
      <path
        d='M559.06 61.15h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bw)',
        }}
      />
      <path
        d='M559.82 61.2h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bx)',
        }}
      />
      <path
        d='M560.61 61.25h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-by)',
        }}
      />
      <path
        d='M561.37 61.29h.34V79.6h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bz)',
        }}
      />
      <path
        d='M562.1 61.32h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bA)',
        }}
      />
      <path
        d='M562.86 61.37h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bB)',
        }}
      />
      <path
        d='M563.6 61.45h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bC)',
        }}
      />
      <path
        d='M564.36 61.48h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bD)',
        }}
      />
      <path
        d='M565.09 61.51h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bE)',
        }}
      />
      <path
        d='M565.85 61.57h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bF)',
        }}
      />
      <path
        d='M566.57 61.6h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bG)',
        }}
      />
      <path
        d='M567.33 61.63h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bH)',
        }}
      />
      <path
        d='M568.06 61.67h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bI)',
        }}
      />
      <path
        d='M568.82 61.72h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bJ)',
        }}
      />
      <path
        d='M569.56 61.79h.34V80.1h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bK)',
        }}
      />
      <path
        d='M570.32 61.83h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bL)',
        }}
      />
      <path
        d='M571.05 61.86h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bM)',
        }}
      />
      <path
        d='M571.81 61.91h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bN)',
        }}
      />
      <path
        d='M572.52 61.91h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bO)',
        }}
      />
      <path
        d='M573.25 61.95h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bP)',
        }}
      />
      <path
        d='M574.01 62h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bQ)',
        }}
      />
      <path
        d='M574.75 62.07h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bR)',
        }}
      />
      <path
        d='M575.51 62.11h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bS)',
        }}
      />
      <path
        d='M576.24 62.14h.34v18.31h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bT)',
        }}
      />
      <path
        d='M577 62.19h.34V80.5H577z'
        style={{
          fill: 'url(#s-61bdda9c5a-bU)',
        }}
      />
      <path
        d='M565.78 267.84h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bV)',
        }}
        transform='rotate(-86.78 448.09 174.637)'
      />
      <path
        d='M565.78 267.07h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bW)',
        }}
        transform='rotate(-86.78 448.089 173.864)'
      />
      <path
        d='M565.78 269.39h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bX)',
        }}
        transform='rotate(-86.78 448.082 176.181)'
      />
      <path
        d='M565.78 268.61h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bY)',
        }}
        transform='rotate(-86.78 448.091 175.409)'
      />
      <path
        d='M565.78 271.02h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-bZ)',
        }}
        transform='rotate(-86.78 448.092 177.813)'
      />
      <path
        d='M565.78 270.25h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ca)',
        }}
        transform='rotate(-86.78 448.09 177.041)'
      />
      <path
        d='M565.78 272.56h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cb)',
        }}
        transform='rotate(-86.78 448.084 179.358)'
      />
      <path
        d='M565.78 271.79h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cc)',
        }}
        transform='rotate(-86.78 448.088 178.58)'
      />
      <path
        d='M565.78 274.19h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cd)',
        }}
        transform='rotate(-86.78 448.088 180.985)'
      />
      <path
        d='M565.78 273.42h.34V304h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ce)',
        }}
        transform='rotate(-86.78 448.082 180.218)'
      />
      <path
        d='M565.78 275.74h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cf)',
        }}
        transform='rotate(-86.78 448.09 182.53)'
      />
      <path
        d='M565.78 274.96h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cg)',
        }}
        transform='rotate(-86.78 448.09 181.757)'
      />
      <path
        d='M565.78 277.37h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ch)',
        }}
        transform='rotate(-86.78 448.085 184.167)'
      />
      <path
        d='M565.78 276.6h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ci)',
        }}
        transform='rotate(-86.78 448.089 183.39)'
      />
      <path
        d='M565.78 278.14h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cj)',
        }}
        transform='rotate(-86.78 448.081 184.934)'
      />
      <path
        d='M565.78 279.77h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ck)',
        }}
        transform='rotate(-86.78 448.09 186.566)'
      />
      <path
        d='M565.78 279h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cl)',
        }}
        transform='rotate(-86.78 448.09 185.794)'
      />
      <path
        d='M565.78 281.32h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cm)',
        }}
        transform='rotate(-86.78 448.083 188.11)'
      />
      <path
        d='M565.78 280.54h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cn)',
        }}
        transform='rotate(-86.78 448.092 187.338)'
      />
      <path
        d='M565.78 282.95h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-co)',
        }}
        transform='rotate(-86.78 448.093 189.743)'
      />
      <path
        d='M565.78 282.17h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cp)',
        }}
        transform='rotate(-86.78 448.091 188.97)'
      />
      <path
        d='M565.78 283.72h.34v30.58h-.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cq)',
        }}
        transform='rotate(-86.78 448.088 190.51)'
      />
      <path
        d='M563.7 79.23l-2.7-.11v-2.31l2.7.14v2.28z'
        style={{
          fill: 'gray',
        }}
      />
      <path
        d='M581.56 300.89l-31.22-1.76v-18.94l31.22 1.81zM551 298.48l29.85 1.69V282.6L551 280.92z'
        style={{
          fill: 'url(#s-61bdda9c5a-f)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M571.23 297.63l-11.5-.63v-9.51l11.5.63zm-10.81-1.28l10.13.56v-8.14l-10.13-.56z'
        style={{
          fill: 'url(#s-61bdda9c5a-cr)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M565.6 297.92a3.39 3.39 0 0 0-1.29-.27 4.5 4.5 0 0 0-1.51.09l1.11-.85 2.76.15z'
        style={{
          fill: '#b0b0b5',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M564.73 298.23l-6.84 2.15a.16.16 0 0 1-.18-.09.15.15 0 0 1 .1-.18l6.83-2.15a.15.15 0 0 1 .18.09.14.14 0 0 1-.09.18z'
        style={{
          fill: 'url(#s-61bdda9c5a-g)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M567.77 300.75a.27.27 0 0 1 0 .16c0 .08-.12.08-.19 0l-2.37-2.68a.25.25 0 0 1 0-.26c0-.08.12-.08.19 0l2.37 2.68a.21.21 0 0 1 0 .1z'
        style={{
          fill: 'url(#s-61bdda9c5a-cs)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M563.24 302c-3.09.07-5.66-.85-5.72-2.05s2.4-2.22 5.5-2.29 5.66.86 5.72 2.05-2.4 2.2-5.5 2.29zm-.21-4.12c-2.92.06-5.24 1-5.19 2.07s2.48 1.9 5.39 1.84 5.24-1 5.18-2.07-2.47-1.94-5.41-1.87z'
        style={{
          fill: 'url(#s-61bdda9c5a-m)',
        }}
        transform='translate(-2.92 -220.08)'
      />
    </g>
    <g
      className='football'
    >
      <path
        d='M130.88 169.49l-18.96-1.2v-1.74l34.7-20.7 16.84 2.3v1.73l-16.23-1.02-27.9 16.92 11.56 1.97-.01 1.74z'
        style={{
          fill: 'url(#s-61bdda9c5a-h)',
        }}
      />
      <path
        d='M130.87 167.75l-18.95-1.2 34.7-20.7 17.63 1.11-.92 1.19-16.41-1.04-30.94 18.46 16.55 1.05-1.66 1.13z'
        style={{
          fill: 'url(#s-61bdda9c5a-i)',
        }}
      />
      <path
        d='M152.37 366.64l-.49-.1 5.68-28.88a2.43 2.43 0 0 1 2.51-2l6.24.36v.5l-6.31-.32a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-ct)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M154.6 366.78l-.49-.09 5.13-26.08a2.42 2.42 0 0 1 2.51-1.95l4.54.26v.5l-4.54-.27a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cu)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M156.77 366.92l-.49-.1 4.6-23.37a2.41 2.41 0 0 1 2.51-1.95l2.9.17v.49l-2.9-.17a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cv)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M158.93 367.06l-.49-.1 4-20.15a2.42 2.42 0 0 1 2.51-1.95l1.4.08v.5l-1.39-.09a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cw)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M161.09 367.19l-.49-.09 3.48-17.68a2.4 2.4 0 0 1 2.19-1.94v.49a1.93 1.93 0 0 0-1.75 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cx)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M163.14 367.32l-.49-.09 3.17-16.11a2.25 2.25 0 0 1 .23-.66l.44.23a2 2 0 0 0-.19.53z'
        style={{
          fill: 'url(#s-61bdda9c5a-cy)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M149.6 366.54l-.49-.1 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.5a2 2 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cz)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M147.1 368.05l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cA)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M144.6 369.44l-.49-.09 6.18-31.44a2.41 2.41 0 0 1 2.52-1.94l8.5.49v.5l-8.5-.5a1.91 1.91 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cB)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M142.1 371l-.48-.1 6.17-31.43a2.43 2.43 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.5a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cC)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M139.38 372.65l-.48-.1 6.17-31.43a2.42 2.42 0 0 1 2.52-1.95l8.5.49v.5l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cD)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M136.89 374.15l-.49-.09 6.18-31.44a2.41 2.41 0 0 1 2.51-1.94l8.51.49v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cE)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M134.39 375.55l-.49-.1 6.18-31.45a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.5a2 2 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cF)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M131.89 377.14l-.49-.09 6.18-31.44a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.5l-8.5-.5a1.91 1.91 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cG)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M129.46 378.71l-.48-.09 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cH)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M127 380.22l-.49-.09 6.18-31.44a2.42 2.42 0 0 1 2.51-1.95l8.51.5v.49l-8.5-.49a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cI)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M124.47 381.62l-.49-.1 6.18-31.43a2.42 2.42 0 0 1 2.51-1.95l8.51.5v.49l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cJ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M122 383.21l-.48-.09 6.17-31.44a2.43 2.43 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.49a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cK)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M119.4 384.73l-.49-.1 6.18-31.43a2.42 2.42 0 0 1 2.52-1.95l8.5.49v.5l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cL)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M117.11 386.19l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.52-2l8.5.5v.49l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cM)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M119.9 386.37l-.49-.1 5.68-28.89a2.43 2.43 0 0 1 2.52-1.95l6.23.37v.49l-6.23-.36a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cN)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M122.13 386.51l-.49-.1 5.13-26.08a2.43 2.43 0 0 1 2.51-1.95l4.54.27v.49l-4.54-.26a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cO)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M124.3 386.64l-.48-.09 4.59-23.38a2.43 2.43 0 0 1 2.52-1.95l2.89.17v.5l-2.89-.17a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cP)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M126.46 386.78l-.49-.1 4-20.15a2.41 2.41 0 0 1 2.52-1.94l1.39.08v.49l-1.39-.08a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-cQ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M128.62 386.92l-.49-.1 3.48-17.67a2.42 2.42 0 0 1 2.2-1.95v.5a1.92 1.92 0 0 0-1.75 1.54z'
        style={{
          fill: 'url(#s-61bdda9c5a-cR)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M130.67 387.05l-.48-.1 3.16-16.1a2.86 2.86 0 0 1 .23-.66l.44.23a1.89 1.89 0 0 0-.18.52z'
        style={{
          fill: 'url(#s-61bdda9c5a-cS)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M131 169.24l-1.6-.64.11-36.54 33.52-20.24 1.92.58-1.49 37.48-1.48-.09v-35.6L131 132.9v36.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-cT)',
        }}
      />
      <path
        d='M132.48 167.87l-1.6 1.62.12-36.59 33.95-20.5v36l-1.48 1.48v-34.85l-30.99 18.71v34.13z'
        style={{
          fill: 'url(#s-61bdda9c5a-j)',
        }}
      />
      <path
        d='M966.54 227.88l17.15.99v-1.67l-9.81-28.89-16.17.35v1.66l14.15.8 8 24.88-14.4.16 1.08 1.72z'
        style={{
          fill: 'url(#s-61bdda9c5a-cV)',
        }}
      />
      <path
        d='M965.48 226.06l18.21 1.04-9.81-28.79-16.92-.78.88 1.13 15.03.85 8.69 26.57-16.09-1.1.01 1.08z'
        style={{
          fill: 'url(#s-61bdda9c5a-cW)',
        }}
      />
      <path
        d='M973.53 419l-3.41-28.16a1.87 1.87 0 0 0-1.77-1.7l-7.73-.31v-.47l7.73.31a2.34 2.34 0 0 1 2.23 2.12L974 418.9z'
        style={{
          fill: 'url(#s-61bdda9c5a-cX)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M971.36 418.86l-3.17-25.42a1.87 1.87 0 0 0-1.78-1.7l-5.61-.22v-.48l5.62.22a2.35 2.35 0 0 1 2.22 2.13l3.17 25.41z'
        style={{
          fill: 'url(#s-61bdda9c5a-cY)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M969.24 418.76L966.3 396a1.88 1.88 0 0 0-1.77-1.7l-3.73-.14v-.47l3.73.14a2.35 2.35 0 0 1 2.23 2.12l2.93 22.78z'
        style={{
          fill: 'url(#s-61bdda9c5a-cZ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M967.14 418.67L964.48 399a1.89 1.89 0 0 0-1.78-1.7l-1.9-.06v-.48l1.9.07A2.35 2.35 0 0 1 965 399l2.66 19.63z'
        style={{
          fill: 'url(#s-61bdda9c5a-da)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M965 418.57l-2.45-17.23a2.18 2.18 0 0 0-1.81-1.67l.08-.47a2.64 2.64 0 0 1 2.2 2.09l2.45 17.22z'
        style={{
          fill: 'url(#s-61bdda9c5a-db)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M963 418.48l-2.31-15.7a1.87 1.87 0 0 0-.13-.53l.44-.18a2.13 2.13 0 0 1 .16.66l2.31 15.68z'
        style={{
          fill: 'url(#s-61bdda9c5a-dc)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.05 419l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dd)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.83 421.22L973.18 391a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.66 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-de)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M977.61 423.36l-3.61-30.2a2 2 0 0 0-1.92-1.84L962 391v-.47l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-df)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M978.44 426l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3.67 30.25z'
        style={{
          fill: 'url(#s-61bdda9c5a-dg)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M979.2 428l-3.65-30.21a2 2 0 0 0-1.93-1.83l-10-.33v-.47l10 .32a2.52 2.52 0 0 1 2.38 2.22l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dh)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M980 430.18L976.31 400a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-di)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M980.74 432.42l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .32a2.5 2.5 0 0 1 2.37 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dj)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M981.58 435.11l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dk)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M982.39 437.47l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dl)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M983.18 439.86l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.37 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dm)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984 442.25l-3.66-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.38 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dn)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984.45 443.73L981.17 415a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.28 28.77z'
        style={{
          fill: 'url(#s-61bdda9c5a-do)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984.92 445.4l-3-28.23a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3 28.22z'
        style={{
          fill: 'url(#s-61bdda9c5a-dp)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M985.39 446.47l-2.61-26.68a2 2 0 0 0-1.92-1.83l-10.63-.33v-.48l10.64.33a2.52 2.52 0 0 1 2.38 2.26l2.6 26.68z'
        style={{
          fill: 'url(#s-61bdda9c5a-dq)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M983.41 446.57l-3.68-24.87A1.88 1.88 0 0 0 978 420l-7.72-.3v-.48l7.72.31a2.34 2.34 0 0 1 2.23 2.12l3.69 24.86z'
        style={{
          fill: 'url(#s-61bdda9c5a-dr)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M981.21 446.6l-3.41-22.26a1.88 1.88 0 0 0-1.78-1.7l-5.61-.22v-.48l5.61.23a2.35 2.35 0 0 1 2.23 2.12l3.41 22.25z'
        style={{
          fill: 'url(#s-61bdda9c5a-ds)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M978.68 446.38l-2.77-19.5a1.87 1.87 0 0 0-1.78-1.7l-3.72-.15v-.47l3.72.14a2.35 2.35 0 0 1 2.23 2.12l2.77 19.5z'
        style={{
          fill: 'url(#s-61bdda9c5a-dt)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.34 446.35l-2.26-16.42a1.86 1.86 0 0 0-1.77-1.7l-1.9-.07v-.48l1.9.07a2.35 2.35 0 0 1 2.23 2.12l2.25 16.42z'
        style={{
          fill: 'url(#s-61bdda9c5a-du)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M974.23 446.26l-2-14a2.2 2.2 0 0 0-1.82-1.68l.09-.47a2.65 2.65 0 0 1 2.2 2.09l2 13.82z'
        style={{
          fill: 'url(#s-61bdda9c5a-dv)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M972.17 445.83l-1.85-12.14a2.25 2.25 0 0 0-.12-.54l.44-.17a2.37 2.37 0 0 1 .15.65l1.85 12.13z'
        style={{
          fill: 'url(#s-61bdda9c5a-dw)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M966.43 227.65l1.54-.64-.37-31.6-9.47-29.7h-2.09l1.68 34.62 1.42-.1-.19-25.74 7.23 21.73.25 31.43z'
        style={{
          fill: 'url(#s-61bdda9c5a-dx)',
        }}
      />
      <path
        d='M965 226.34l1.54 1.54-.36-31.66-10.14-30.51.24 33.21 1.43 1.41-.14-24.84 7.19 21.55.24 29.3z'
        style={{
          fill: 'url(#s-61bdda9c5a-dy)',
        }}
      />
    </g>
    <g
      id='volleyballNet'
    >
      <path
        d='M550.49 152.64v-40.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-61bdda9c5a-k)',
        }}
      />
      <path
        d='M545.85 133.03l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M545.85 122.5l-37.53 48.58M545.85 124.26l-37.53 48.55M545.85 125.89l-37.53 48.69M545.85 127.53l-37.53 48.81M545.91 129.03l-37.59 48.93M545.85 130.46l-37.53 49.22M545.77 131.81l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M510.32 165.91v15.38M509.65 166.3v15.38M508.82 167.32v15.38M510.97 165.07v15.2M511.66 164.17v15.04M512.37 162.97v15.39M513.01 162.14v15.19M513.71 161.23v15.04M514.46 160.43v15.39M515.11 159.6v15.19M515.81 158.69v15.04M516.51 157.5v15.38M517.15 156.66v15.2M517.85 155.76v15.04M518.57 155.08v15.38M519.22 154.24v15.2M519.92 153.34v15.04M520.62 152.15v15.38M521.26 151.31v15.19M521.96 150.41v15.03M522.6 149.71v15.38M523.25 148.87v15.2M523.95 147.97V163M524.65 146.77v15.39M525.3 145.94v15.19M525.99 145.6v13.9M526.74 144.8v14.25M527.39 143.96v14.06M528.09 143.06v13.9M528.79 141.87v14.24M529.44 141.03v14.06M530.14 140.13v13.9M530.85 139.45v14.25M531.5 138.61v14.06M532.2 137.71v13.9M532.9 136.51v14.25M533.55 135.68v14.06M534.24 134.77v13.9M534.93 133.82v13.9M535.67 133.02v14.25M536.32 132.19v14.06M537.02 131.28v13.9M537.72 130.09v14.25M538.37 129.25v14.06M539.07 128.35v13.9M539.78 127.67v14.25M540.43 126.83v14.06M541.13 125.93v13.9M541.83 124.74v14.24M542.48 123.9v14.06M543.18 122.99v13.91M543.75 122.09v14.25M544.39 121.26v14.06M545.09 120.35v13.91'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M507.69 168.96l-7.87 9.28M507.82 183.94l-9.43 14.45M507.69 178.77l-7.87 10.82M545.85 119.92l4.76-6.31M545.91 129.03l4.63-5.67M545.91 132.84l4.58-4.97'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M545.85 133.03v-13.11l-38.16 49.04v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-o)',
        }}
      />
      <path
        d='M499.82 225.56v-50.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-61bdda9c5a-dz)',
        }}
      />
    </g>
    <g
      id='basketball'
      className='basketballTwo'
    >
      <path
        d='M131.42 168.56l-18.97-1.19v-1.74l34.7-20.7 16.85 2.29v1.74l-16.24-1.02-27.9 16.92 11.56 1.97v1.73z'
        style={{
          fill: 'url(#s-61bdda9c5a-dA)',
        }}
      />
      <path
        d='M131.4 166.83l-18.95-1.2 34.7-20.7 17.63 1.11-.91 1.18-16.41-1.03-30.95 18.46 16.55 1.04-1.66 1.14z'
        style={{
          fill: 'url(#s-61bdda9c5a-dB)',
        }}
      />
      <path
        d='M152.9 365.72l-.48-.1 5.67-28.88a2.41 2.41 0 0 1 2.52-1.95l6.23.36v.5l-6.23-.37a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dC)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M155.13 365.86l-.49-.1 5.13-26.07a2.41 2.41 0 0 1 2.51-1.95l4.54.26v.5l-4.53-.27a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dD)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M157.3 366l-.48-.1 4.59-23.38a2.43 2.43 0 0 1 2.52-1.94l2.89.16v.5l-2.89-.17a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dE)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M159.46 366.13L159 366l4-20.15a2.43 2.43 0 0 1 2.52-1.95l1.39.08v.49l-1.39-.08a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dF)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M161.62 366.27l-.48-.09 3.47-17.68a2.42 2.42 0 0 1 2.2-1.95v.5a1.91 1.91 0 0 0-1.74 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dG)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M163.67 366.4l-.48-.1 3.16-16.1a2.61 2.61 0 0 1 .24-.66l.43.23a2 2 0 0 0-.18.53z'
        style={{
          fill: 'url(#s-61bdda9c5a-dH)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M150.13 365.62l-.49-.1 6.18-31.43a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dI)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M147.63 367.13l-.48-.1 6.17-31.43a2.43 2.43 0 0 1 2.52-2l8.5.5v.49l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dJ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M145.13 368.52l-.48-.09 6.17-31.43a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.5l-8.5-.5a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dK)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M142.64 370.12l-.49-.1 6.18-31.43a2.41 2.41 0 0 1 2.51-1.95l8.51.49v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dL)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M139.92 371.72l-.49-.09 6.18-31.44a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.5l-8.51-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dM)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M137.42 373.23l-.49-.09 6.18-31.44a2.43 2.43 0 0 1 2.52-1.95l8.5.5v.5l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dN)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M134.92 374.63l-.49-.1 6.18-31.43a2.43 2.43 0 0 1 2.52-2l8.5.5v.49l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dO)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M132.42 376.22l-.48-.09 6.17-31.44a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.49a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dP)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M130 377.79l-.49-.09 6.18-31.44a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.49a1.91 1.91 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dQ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M127.5 379.3l-.48-.09 6.17-31.44a2.43 2.43 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.49a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dR)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M125 380.7l-.48-.1 6.17-31.43a2.42 2.42 0 0 1 2.52-1.95l8.5.49v.5l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dS)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M122.5 382.29l-.48-.1 6.18-31.43a2.43 2.43 0 0 1 2.51-1.95l8.51.5v.49l-8.51-.49a1.94 1.94 0 0 0-2 1.54z'
        style={{
          fill: 'url(#s-61bdda9c5a-dT)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M119.93 383.8l-.48-.09 6.17-31.44a2.43 2.43 0 0 1 2.52-1.94l8.5.49v.5l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dU)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M117.64 385.27l-.48-.1 6.17-31.43a2.44 2.44 0 0 1 2.52-1.95l8.5.5v.49l-8.5-.5a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dV)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M120.43 385.44l-.48-.09 5.67-28.89a2.44 2.44 0 0 1 2.52-1.95l6.23.37v.49l-6.23-.36a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dW)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M122.66 385.58l-.48-.09 5.12-26.08a2.44 2.44 0 0 1 2.52-2l4.53.27v.49l-4.53-.26a1.92 1.92 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dX)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M124.84 385.72l-.49-.09 4.59-23.38a2.44 2.44 0 0 1 2.52-1.95l2.89.17v.49l-2.89-.17a1.94 1.94 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dY)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M127 385.86l-.48-.1 4-20.15a2.43 2.43 0 0 1 2.51-1.95l1.39.09v.49l-1.39-.08a1.93 1.93 0 0 0-2 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-dZ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M129.15 386l-.48-.1 3.47-17.67a2.43 2.43 0 0 1 2.2-2v.49a1.92 1.92 0 0 0-1.75 1.55z'
        style={{
          fill: 'url(#s-61bdda9c5a-ea)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M131.21 386.13l-.49-.1 3.17-16.1a2.16 2.16 0 0 1 .23-.66l.44.23a1.91 1.91 0 0 0-.19.52z'
        style={{
          fill: 'url(#s-61bdda9c5a-eb)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M131.53 168.32l-1.6-.64.11-36.54 33.52-20.24 1.93.57-1.49 37.49-1.49-.09v-35.6l-30.98 18.71v36.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-ec)',
        }}
      />
      <path
        d='M133.02 166.95l-1.6 1.61.11-36.58 33.96-20.51v36l-1.49 1.48v-34.84l-30.98 18.71v34.13z'
        style={{
          fill: 'url(#s-61bdda9c5a-ed)',
        }}
      />
      <path
        d='M152.39 119.17l-1.01.64-.48-1.4-1.01-19.72 1.01-.92 8.8.55-.01 1.35-7.3-.32v19.82z'
        style={{
          fill: 'url(#s-61bdda9c5a-ef)',
        }}
      />
      <path
        d='M159.69 108.43l-8.09-.53-.22-.52 1.01-.91 7.31.47-.01 1.49z'
        style={{
          fill: 'url(#s-61bdda9c5a-eg)',
        }}
      />
      <path
        d='M151.38 100.27l7.3.45.01-1.49-8.8-.54v20.63l1.49.49v-10.95l7.3.48.01-1.48-7.31-.48v-7.11z'
        style={{
          fill: 'url(#s-61bdda9c5a-eh)',
        }}
      />
      <path
        d='M159.69 99.72l-1.01 1 .01-1.49 1.01-.91-.01 1.4z'
        style={{
          fill: 'url(#s-61bdda9c5a-ei)',
        }}
      />
      <path
        d='M159.69 108.47l-1.01.87.01-1.48 1.01-.92-.01 1.53z'
        style={{
          fill: 'url(#s-61bdda9c5a-ej)',
        }}
      />
      <path
        d='M144.6 321.62h9.74v.99h-9.74z'
        style={{
          fill: 'url(#s-61bdda9c5a-l)',
        }}
        transform='rotate(-31.1 -247.445 217.303)'
      />
      <path
        d='M144.6 330.24h9.74v.99h-9.74z'
        style={{
          fill: 'url(#s-61bdda9c5a-ek)',
        }}
        transform='rotate(-31.1 -247.465 225.932)'
      />
      <path
        d='M144.05 124.2l-1.01.64-.47-1.4-1.01-19.73 1.01-.91 8.8.55-.02 1.38-7.3-.35v19.82z'
        style={{
          fill: 'url(#s-61bdda9c5a-el)',
        }}
      />
      <path
        d='M151.35 113.46l-8.09-.53-.22-.52 1.01-.92 7.32.48-.02 1.49z'
        style={{
          fill: 'url(#s-61bdda9c5a-em)',
        }}
      />
      <path
        d='M143.04 105.3l7.3.45.02-1.49-8.8-.55v20.64l1.48.49v-10.95l7.3.48.02-1.48-7.32-.48v-7.11z'
        style={{
          fill: 'url(#s-61bdda9c5a-en)',
        }}
      />
      <path
        d='M151.35 104.75l-1.01 1 .02-1.49 1.01-.91-.02 1.4z'
        style={{
          fill: 'url(#s-61bdda9c5a-eo)',
        }}
      />
      <path
        d='M151.35 113.5l-1.01.87.02-1.48 1.01-.92-.02 1.53z'
        style={{
          fill: 'url(#s-61bdda9c5a-ep)',
        }}
      />
      <path
        d='M149.38 318.76h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eq)',
        }}
        transform='matrix(.86 -.52 .52 .86 -145.3 -92.24)'
      />
      <path
        d='M149.38 319.37h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-er)',
        }}
        transform='rotate(-31.2 -237.827 214.683)'
      />
      <path
        d='M149.38 320.01h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-es)',
        }}
        transform='rotate(-31.2 -237.836 215.337)'
      />
      <path
        d='M149.38 320.58h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-et)',
        }}
        transform='rotate(-31.2 -237.838 215.896)'
      />
      <path
        d='M149.38 321.2h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eu)',
        }}
        transform='matrix(.86 -.52 .52 .86 -146.56 -91.89)'
      />
      <path
        d='M149.38 321.84h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-ev)',
        }}
        transform='rotate(-31.2 -237.822 217.155)'
      />
      <path
        d='M149.38 322.42h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-ew)',
        }}
        transform='matrix(.86 -.52 .52 .86 -147.2 -91.71)'
      />
      <path
        d='M149.38 323.04h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-ex)',
        }}
        transform='matrix(.86 -.52 .52 .86 -147.51 -91.62)'
      />
      <path
        d='M149.38 323.68h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-ey)',
        }}
        transform='rotate(-31.2 -236.88 218.28)'
      />
      <path
        d='M149.38 324.25h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-ez)',
        }}
        transform='matrix(.86 -.52 .52 .86 -148.14 -91.44)'
      />
      <path
        d='M149.38 324.87h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eA)',
        }}
        transform='matrix(.86 -.52 .52 .86 -148.46 -91.36)'
      />
      <path
        d='M149.38 325.51h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eB)',
        }}
        transform='rotate(-31.2 -237.823 220.823)'
      />
      <path
        d='M149.38 326.13h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eC)',
        }}
        transform='matrix(.86 -.52 .52 .86 -149.12 -91.17)'
      />
      <path
        d='M149.38 326.75h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eD)',
        }}
        transform='matrix(.86 -.52 .52 .86 -149.44 -91.08)'
      />
      <path
        d='M149.38 327.39h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eE)',
        }}
        transform='matrix(.86 -.52 .52 .86 -149.77 -90.99)'
      />
      <path
        d='M149.38 327.96h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eF)',
        }}
        transform='rotate(-31.2 -237.832 223.272)'
      />
      <path
        d='M149.38 328.57h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eG)',
        }}
        transform='matrix(.86 -.52 .52 .86 -150.38 -90.82)'
      />
      <path
        d='M149.38 329.22h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eH)',
        }}
        transform='matrix(.86 -.52 .52 .86 -150.71 -90.73)'
      />
      <path
        d='M149.38 329.8h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eI)',
        }}
        transform='matrix(.86 -.52 .52 .86 -151.02 -90.64)'
      />
      <path
        d='M149.38 330.42h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eJ)',
        }}
        transform='rotate(-31.2 -237.827 225.744)'
      />
      <path
        d='M149.38 331.06h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eK)',
        }}
        transform='matrix(.86 -.52 .52 .86 -151.67 -90.46)'
      />
      <path
        d='M149.38 331.63h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eL)',
        }}
        transform='rotate(-31.2 -237.837 226.958)'
      />
      <path
        d='M149.38 332.24h16.67v.2h-16.67z'
        style={{
          fill: 'url(#s-61bdda9c5a-eM)',
        }}
        transform='matrix(.86 -.52 .52 .86 -152.28 -90.29)'
      />
      <path
        d='M148.3 101.76h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eN)',
        }}
      />
      <path
        d='M148.76 101.47h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eO)',
        }}
      />
      <path
        d='M149.22 101.21h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eP)',
        }}
      />
      <path
        d='M149.68 100.92h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eQ)',
        }}
      />
      <path
        d='M150.13 100.68h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eR)',
        }}
      />
      <path
        d='M150.59 100.4h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eS)',
        }}
      />
      <path
        d='M151.05 100.13h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eT)',
        }}
      />
      <path
        d='M151.51 99.84h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eU)',
        }}
      />
      <path
        d='M151.98 99.55h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eV)',
        }}
      />
      <path
        d='M152.44 99.26h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eW)',
        }}
      />
      <path
        d='M152.9 99h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eX)',
        }}
      />
      <path
        d='M153.37 98.71h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eY)',
        }}
      />
      <path
        d='M153.81 98.47h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-eZ)',
        }}
      />
      <path
        d='M154.28 98.19h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fa)',
        }}
      />
      <path
        d='M154.74 97.92h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fb)',
        }}
      />
      <path
        d='M155.2 97.64h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fc)',
        }}
      />
      <path
        d='M155.66 97.36h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fd)',
        }}
      />
      <path
        d='M156.12 97.07h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fe)',
        }}
      />
      <path
        d='M156.58 96.81h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-ff)',
        }}
      />
      <path
        d='M157.04 96.52h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fg)',
        }}
      />
      <path
        d='M157.49 96.28h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fh)',
        }}
      />
      <path
        d='M157.95 96h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fi)',
        }}
      />
      <path
        d='M158.41 95.73h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fj)',
        }}
      />
      <path
        d='M158.87 95.45h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fk)',
        }}
      />
      <path
        d='M159.31 95.12h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fl)',
        }}
      />
      <path
        d='M159.77 94.83h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fm)',
        }}
      />
      <path
        d='M160.23 94.56h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fn)',
        }}
      />
      <path
        d='M160.69 94.28h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fo)',
        }}
      />
      <path
        d='M161.14 94.04h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fp)',
        }}
      />
      <path
        d='M161.6 93.75h.2v15.07h-.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-fq)',
        }}
      />
      <path
        d='M150.34 337.8v-15.66l14.76-8.94v15.67zm.49-15.38v14.51l13.77-8.34v-14.51z'
        style={{
          fill: 'url(#s-61bdda9c5a-n)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M154.18 333v-6.9l7.16-4.29v6.83zm.69-6.49v5.26l5.78-3.5V323z'
        style={{
          fill: 'url(#s-61bdda9c5a-fr)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M154.27 112.78l1.99-1.2v-1.87l-1.99 1.17v1.9z'
        style={{
          fill: '#5a5a5a',
        }}
      />
      <path
        d='M158.73 331.61a2.36 2.36 0 0 1 .74-.62 3.6 3.6 0 0 1 1-.45l-1.31-.75-1.74 1z'
        style={{
          fill: '#b0b0b5',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M158.73 332l6.09-1.06a.14.14 0 0 0 .1-.14.12.12 0 0 0-.14-.1l-6.09 1.06a.12.12 0 0 0-.1.14.12.12 0 0 0 .14.1z'
        style={{
          fill: 'url(#s-61bdda9c5a-fs)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M159.45 334.39a.13.13 0 0 0 .1 0 .12.12 0 0 0 0-.17l-2-1.57a.12.12 0 1 0-.15.19l2 1.57z'
        style={{
          fill: 'url(#s-61bdda9c5a-ft)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M158.35 332.73c0-1.36 1.85-2.47 4.12-2.47s4.12 1.11 4.12 2.47-1.85 2.47-4.12 2.47-4.12-1.11-4.12-2.47zm.24 0c0 1.23 1.74 2.23 3.88 2.23s3.88-1 3.88-2.23-1.74-2.23-3.88-2.23-3.88 1-3.88 2.23z'
        style={{
          fill: 'url(#s-61bdda9c5a-fu)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M966.54 227.88l17.15.99v-1.67l-9.81-28.89-16.17.35v1.66l14.15.8 8 24.88-14.4.16 1.08 1.72z'
        style={{
          fill: 'url(#s-61bdda9c5a-cV)',
        }}
      />
      <path
        d='M965.48 226.06l18.21 1.04-9.81-28.79-16.92-.78.88 1.13 15.03.85 8.69 26.57-16.09-1.1.01 1.08z'
        style={{
          fill: 'url(#s-61bdda9c5a-cW)',
        }}
      />
      <path
        d='M973.53 419l-3.41-28.16a1.87 1.87 0 0 0-1.77-1.7l-7.73-.31v-.47l7.73.31a2.34 2.34 0 0 1 2.23 2.12L974 418.9z'
        style={{
          fill: 'url(#s-61bdda9c5a-cX)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M971.36 418.86l-3.17-25.42a1.87 1.87 0 0 0-1.78-1.7l-5.61-.22v-.48l5.62.22a2.35 2.35 0 0 1 2.22 2.13l3.17 25.41z'
        style={{
          fill: 'url(#s-61bdda9c5a-cY)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M969.24 418.76L966.3 396a1.88 1.88 0 0 0-1.77-1.7l-3.73-.14v-.47l3.73.14a2.35 2.35 0 0 1 2.23 2.12l2.93 22.78z'
        style={{
          fill: 'url(#s-61bdda9c5a-cZ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M967.14 418.67L964.48 399a1.89 1.89 0 0 0-1.78-1.7l-1.9-.06v-.48l1.9.07A2.35 2.35 0 0 1 965 399l2.66 19.63z'
        style={{
          fill: 'url(#s-61bdda9c5a-da)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M965 418.57l-2.45-17.23a2.18 2.18 0 0 0-1.81-1.67l.08-.47a2.64 2.64 0 0 1 2.2 2.09l2.45 17.22z'
        style={{
          fill: 'url(#s-61bdda9c5a-db)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M963 418.48l-2.31-15.7a1.87 1.87 0 0 0-.13-.53l.44-.18a2.13 2.13 0 0 1 .16.66l2.31 15.68z'
        style={{
          fill: 'url(#s-61bdda9c5a-dc)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.05 419l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dd)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.83 421.22L973.18 391a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.66 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-de)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M977.61 423.36l-3.61-30.2a2 2 0 0 0-1.92-1.84L962 391v-.47l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-df)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M978.44 426l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3.67 30.25z'
        style={{
          fill: 'url(#s-61bdda9c5a-dg)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M979.2 428l-3.65-30.21a2 2 0 0 0-1.93-1.83l-10-.33v-.47l10 .32a2.52 2.52 0 0 1 2.38 2.22l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dh)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M980 430.18L976.31 400a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-di)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M980.74 432.42l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .32a2.5 2.5 0 0 1 2.37 2.27l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dj)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M981.58 435.11l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dk)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M982.39 437.47l-3.65-30.2a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.49 2.49 0 0 1 2.37 2.26l3.65 30.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-dl)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M983.18 439.86l-3.65-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.37 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dm)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984 442.25l-3.66-30.2a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.51 2.51 0 0 1 2.38 2.26l3.65 30.2z'
        style={{
          fill: 'url(#s-61bdda9c5a-dn)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984.45 443.73L981.17 415a2 2 0 0 0-1.92-1.83l-10-.33v-.48l10 .33a2.5 2.5 0 0 1 2.37 2.26l3.28 28.77z'
        style={{
          fill: 'url(#s-61bdda9c5a-do)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M984.92 445.4l-3-28.23a2 2 0 0 0-1.92-1.84l-10-.33v-.47l10 .33a2.5 2.5 0 0 1 2.38 2.26l3 28.22z'
        style={{
          fill: 'url(#s-61bdda9c5a-dp)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M985.39 446.47l-2.61-26.68a2 2 0 0 0-1.92-1.83l-10.63-.33v-.48l10.64.33a2.52 2.52 0 0 1 2.38 2.26l2.6 26.68z'
        style={{
          fill: 'url(#s-61bdda9c5a-dq)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M983.41 446.57l-3.68-24.87A1.88 1.88 0 0 0 978 420l-7.72-.3v-.48l7.72.31a2.34 2.34 0 0 1 2.23 2.12l3.69 24.86z'
        style={{
          fill: 'url(#s-61bdda9c5a-dr)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M981.21 446.6l-3.41-22.26a1.88 1.88 0 0 0-1.78-1.7l-5.61-.22v-.48l5.61.23a2.35 2.35 0 0 1 2.23 2.12l3.41 22.25z'
        style={{
          fill: 'url(#s-61bdda9c5a-ds)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M978.68 446.38l-2.77-19.5a1.87 1.87 0 0 0-1.78-1.7l-3.72-.15v-.47l3.72.14a2.35 2.35 0 0 1 2.23 2.12l2.77 19.5z'
        style={{
          fill: 'url(#s-61bdda9c5a-dt)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M976.34 446.35l-2.26-16.42a1.86 1.86 0 0 0-1.77-1.7l-1.9-.07v-.48l1.9.07a2.35 2.35 0 0 1 2.23 2.12l2.25 16.42z'
        style={{
          fill: 'url(#s-61bdda9c5a-du)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M974.23 446.26l-2-14a2.2 2.2 0 0 0-1.82-1.68l.09-.47a2.65 2.65 0 0 1 2.2 2.09l2 13.82z'
        style={{
          fill: 'url(#s-61bdda9c5a-dv)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M972.17 445.83l-1.85-12.14a2.25 2.25 0 0 0-.12-.54l.44-.17a2.37 2.37 0 0 1 .15.65l1.85 12.13z'
        style={{
          fill: 'url(#s-61bdda9c5a-dw)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M966.43 227.65l1.54-.64-.37-31.6-9.47-29.7h-2.09l1.68 34.62 1.42-.1-.19-25.74 7.23 21.73.25 31.43z'
        style={{
          fill: 'url(#s-61bdda9c5a-dx)',
        }}
      />
      <path
        d='M965 226.34l1.54 1.54-.36-31.66-10.14-30.51.24 33.21 1.43 1.41-.14-24.84 7.19 21.55.24 29.3z'
        style={{
          fill: 'url(#s-61bdda9c5a-dy)',
        }}
      />
      <path
        d='M960.02 177.38l.56 1.67.45-1.35.97-18.93-.74-.68-8.46-.48.02 1.21 7.2.75v17.81z'
        style={{
          fill: 'url(#s-61bdda9c5a-fv)',
        }}
      />
      <path
        d='M953.23 167.82l7.14-.21.21-.5-.56-.49-6.77-.38-.02 1.58z'
        style={{
          fill: 'url(#s-61bdda9c5a-fw)',
        }}
      />
      <path
        d='M960.58 160.28l-7.01-.43-.04-1.55 8.47.47v20.35l-1.42-.07v-10.51l-7.01-.42-.02-1.43 7.03.42v-6.83z'
        style={{
          fill: 'url(#s-61bdda9c5a-fx)',
        }}
      />
      <path
        d='M952.82 159l.75.85-.04-1.55-.73-.69.02 1.39z'
        style={{
          fill: 'url(#s-61bdda9c5a-fy)',
        }}
      />
      <path
        d='M953.23 167.82l.34.29-.02-1.42-.31-.45-.01 1.58z'
        style={{
          fill: 'url(#s-61bdda9c5a-fz)',
        }}
      />
      <path
        d='M964.79 387.73h.95v6.92h-.95z'
        style={{
          fill: 'url(#s-61bdda9c5a-fA)',
        }}
        transform='rotate(-17.86 263.785 290.494)'
      />
      <path
        d='M964.79 379.51h.95v6.87h-.95z'
        style={{
          fill: 'url(#s-61bdda9c5a-fB)',
        }}
        transform='rotate(-18.01 269.66 282.172)'
      />
      <path
        d='M962.23 183.94l.55 1.66.46-1.34.97-18.93-.75-.68-8.45-.49.01 1.22 7.21.75v17.81z'
        style={{
          fill: 'url(#s-61bdda9c5a-fC)',
        }}
      />
      <path
        d='M955.43 174.38l7.14-.21.21-.5-.55-.5-6.78-.37-.02 1.58z'
        style={{
          fill: 'url(#s-61bdda9c5a-fD)',
        }}
      />
      <path
        d='M962.78 166.84l-7.01-.43-.03-1.55 8.47.47v20.35l-1.43-.08v-10.5l-7.01-.42-.01-1.43 7.02.42v-6.83z'
        style={{
          fill: 'url(#s-61bdda9c5a-fE)',
        }}
      />
      <path
        d='M955.03 165.56l.74.85-.03-1.55-.73-.7.02 1.4z'
        style={{
          fill: 'url(#s-61bdda9c5a-fF)',
        }}
      />
      <path
        d='M955.43 174.38l.34.29-.01-1.43-.31-.44-.02 1.58z'
        style={{
          fill: 'url(#s-61bdda9c5a-fG)',
        }}
      />
      <path
        d='M955.61 164.04l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fH)',
        }}
      />
      <path
        d='M955.61 164.63l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fI)',
        }}
      />
      <path
        d='M955.61 165.25l-2.83-8.29.04-.02 2.84 8.3-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fJ)',
        }}
      />
      <path
        d='M955.61 165.8l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fK)',
        }}
      />
      <path
        d='M955.61 166.39l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fL)',
        }}
      />
      <path
        d='M955.61 167l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fM)',
        }}
      />
      <path
        d='M955.61 167.57l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fN)',
        }}
      />
      <path
        d='M955.61 168.16l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fO)',
        }}
      />
      <path
        d='M955.61 168.77l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fP)',
        }}
      />
      <path
        d='M955.61 169.32l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fQ)',
        }}
      />
      <path
        d='M955.61 169.91l-2.83-8.29.04-.02 2.84 8.3-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fR)',
        }}
      />
      <path
        d='M955.61 170.53l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fS)',
        }}
      />
      <path
        d='M955.61 171.13l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fT)',
        }}
      />
      <path
        d='M955.61 171.72l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fU)',
        }}
      />
      <path
        d='M955.61 172.33l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fV)',
        }}
      />
      <path
        d='M955.61 172.88l-2.83-8.29.04-.02 2.84 8.3-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fW)',
        }}
      />
      <path
        d='M955.61 173.47l-2.83-8.29.04-.02 2.84 8.3-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-fX)',
        }}
      />
      <path
        d='M955.61 174.09l-2.83-8.3.04-.01 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fY)',
        }}
      />
      <path
        d='M955.61 174.65l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-fZ)',
        }}
      />
      <path
        d='M955.61 175.24l-2.83-8.29.04-.02 2.84 8.29-.05.02z'
        style={{
          fill: 'url(#s-61bdda9c5a-ga)',
        }}
      />
      <path
        d='M955.61 175.85l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-gb)',
        }}
      />
      <path
        d='M955.61 176.4l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-gc)',
        }}
      />
      <path
        d='M955.61 176.99l-2.83-8.29.04-.01 2.84 8.29-.05.01z'
        style={{
          fill: 'url(#s-61bdda9c5a-gd)',
        }}
      />
      <path
        d='M955.47 162.76h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-ge)',
        }}
      />
      <path
        d='M955.38 162.48h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gf)',
        }}
      />
      <path
        d='M955.28 162.23h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gg)',
        }}
      />
      <path
        d='M955.19 161.95h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gh)',
        }}
      />
      <path
        d='M955.1 161.72h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gi)',
        }}
      />
      <path
        d='M955.01 161.45h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gj)',
        }}
      />
      <path
        d='M954.92 161.19h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gk)',
        }}
      />
      <path
        d='M954.83 160.92h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gl)',
        }}
      />
      <path
        d='M954.73 160.64h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gm)',
        }}
      />
      <path
        d='M954.64 160.36h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gn)',
        }}
      />
      <path
        d='M954.55 160.1h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-go)',
        }}
      />
      <path
        d='M954.46 159.83h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gp)',
        }}
      />
      <path
        d='M954.37 159.6h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gq)',
        }}
      />
      <path
        d='M954.28 159.33h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gr)',
        }}
      />
      <path
        d='M954.19 159.07h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gs)',
        }}
      />
      <path
        d='M954.1 158.8h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gt)',
        }}
      />
      <path
        d='M954 158.53h.05V173H954z'
        style={{
          fill: 'url(#s-61bdda9c5a-gu)',
        }}
      />
      <path
        d='M953.91 158.26h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gv)',
        }}
      />
      <path
        d='M953.82 158h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gw)',
        }}
      />
      <path
        d='M953.73 157.73h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gx)',
        }}
      />
      <path
        d='M953.64 157.5h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gy)',
        }}
      />
      <path
        d='M953.55 157.23h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gz)',
        }}
      />
      <path
        d='M953.46 156.97h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gA)',
        }}
      />
      <path
        d='M953.37 156.7h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gB)',
        }}
      />
      <path
        d='M953.28 156.38h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gC)',
        }}
      />
      <path
        d='M953.19 156.11h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gD)',
        }}
      />
      <path
        d='M953.1 155.85h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gE)',
        }}
      />
      <path
        d='M953 155.57h.05v14.47H953z'
        style={{
          fill: 'url(#s-61bdda9c5a-gF)',
        }}
      />
      <path
        d='M952.92 155.35h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gG)',
        }}
      />
      <path
        d='M952.82 155.07h.05v14.47h-.05z'
        style={{
          fill: 'url(#s-61bdda9c5a-gH)',
        }}
      />
      <path
        d='M958.67 398.46l-3.07-9v-15.2l3.07 9zm-2.83-9l2.59 7.6v-13.78l-2.59-7.6z'
        style={{
          fill: 'url(#s-61bdda9c5a-gI)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M958 394.37l-1.76-5.19V382l1.76 5.13zm-1.29-5.23l.81 2.37v-4.36l-.81-2.34z'
        style={{
          fill: 'url(#s-61bdda9c5a-gJ)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M954.12 173.17l-.54-1.58.01-1.79.53 1.55v1.82z'
        style={{
          fill: '#5a5a5a',
        }}
      />
      <path
        d='M955.62 391.44a1.81 1.81 0 0 0-.44-1 3.22 3.22 0 0 0-.79-.72l2.16.18.49 1.51z'
        style={{
          fill: '#b0b0b5',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M955.19 390.88l-5.84-1a.11.11 0 0 1-.09-.13.11.11 0 0 1 .13-.1l5.84 1a.12.12 0 0 1 .1.14.12.12 0 0 1-.14.09z'
        style={{
          fill: 'url(#s-61bdda9c5a-gK)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M954.5 393.17a.12.12 0 0 1-.09-.05.11.11 0 0 1 0-.16l1.93-1.5a.12.12 0 0 1 .17 0 .12.12 0 0 1 0 .16l-1.94 1.51z'
        style={{
          fill: 'url(#s-61bdda9c5a-gL)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M951.6 394c-2.18 0-4-1.07-4-2.38s1.77-2.37 4-2.37 4 1.07 4 2.37-1.81 2.38-4 2.38zm0-4.52c-2.05 0-3.72 1-3.72 2.14s1.67 2.14 3.72 2.14 3.73-1 3.73-2.14-1.67-2.19-3.73-2.19z'
        style={{
          fill: 'url(#s-61bdda9c5a-gM)',
        }}
        transform='translate(-2.92 -220.08)'
      />
    </g>
    <g
      id='volleyballNet'
    >
      <path
        d='M550.49 152.64v-40.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-61bdda9c5a-gN)',
        }}
      />
      <path
        d='M545.85 133.03l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M545.85 122.5l-37.53 48.58M545.85 124.26l-37.53 48.55M545.85 125.89l-37.53 48.69M545.85 127.53l-37.53 48.81M545.91 129.03l-37.59 48.93M545.85 130.46l-37.53 49.22M545.77 131.81l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M510.32 165.91v15.38M509.65 166.3v15.38M508.82 167.32v15.38M510.97 165.07v15.2M511.66 164.17v15.04M512.37 162.97v15.39M513.01 162.14v15.19M513.71 161.23v15.04M514.46 160.43v15.39M515.11 159.6v15.19M515.81 158.69v15.04M516.51 157.5v15.38M517.15 156.66v15.2M517.85 155.76v15.04M518.57 155.08v15.38M519.22 154.24v15.2M519.92 153.34v15.04M520.62 152.15v15.38M521.26 151.31v15.19M521.96 150.41v15.03M522.6 149.71v15.38M523.25 148.87v15.2M523.95 147.97V163M524.65 146.77v15.39M525.3 145.94v15.19M525.99 145.6v13.9M526.74 144.8v14.25M527.39 143.96v14.06M528.09 143.06v13.9M528.79 141.87v14.24M529.44 141.03v14.06M530.14 140.13v13.9M530.85 139.45v14.25M531.5 138.61v14.06M532.2 137.71v13.9M532.9 136.51v14.25M533.55 135.68v14.06M534.24 134.77v13.9M534.93 133.82v13.9M535.67 133.02v14.25M536.32 132.19v14.06M537.02 131.28v13.9M537.72 130.09v14.25M538.37 129.25v14.06M539.07 128.35v13.9M539.78 127.67v14.25M540.43 126.83v14.06M541.13 125.93v13.9M541.83 124.74v14.24M542.48 123.9v14.06M543.18 122.99v13.91M543.75 122.09v14.25M544.39 121.26v14.06M545.09 120.35v13.91'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M507.69 168.96l-7.87 9.28M507.82 183.94l-9.43 14.45M507.69 178.77l-7.87 10.82M545.85 119.92l4.76-6.31M545.91 129.03l4.63-5.67M545.91 132.84l4.58-4.97'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M545.85 133.03v-13.11l-38.16 49.04v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-o)',
        }}
      />
      <path
        d='M499.82 225.56v-50.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-61bdda9c5a-gO)',
        }}
      />
    </g>
    <g
      id='tennisNet'
    >
      <path
        d='M557.62 138.8l-67.54 99.33'
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M557.15 137.24l-67.07 98.45M557.15 135.27l-67.07 98.45M557.15 133.35l-67.07 98.46M557.15 131.39l-67.07 98.45M557.15 129.44l-67.07 98.45M557.15 127.47l-67.07 98.45M557.15 125.55L490.08 224M557.15 123.59l-67.07 98.45M557.15 121.7l-67.07 98.45M557.15 119.74l-67.07 98.45M557.15 117.82l-67.07 98.45M492.05 210.51v24.7M493.24 208.88v24.62M494.51 207.23l-.04 23.3M495.8 205.04l-.04 23.94M496.99 203.51l-.05 23.59M498.26 201.85l-.04 23.31M499.64 198.89l-.05 25.44M500.82 197.35l-.04 25.1M502.1 195.7l-.04 24.8M503.39 193.51v24.78M504.57 191.98v24.43M505.85 190.32v24.15M507.17 187.52l.04 25.07M508.35 185.99l.04 24.72M509.63 184.33l.04 24.44M510.92 182.15l.04 25.06M512.1 180.61l.06 23.86M513.38 178.96l.06 23.57M514.55 176.7l.06 25.18M515.74 175.16v24.9M517.02 173.5v24.67M518.3 171.32l.01 25.37M519.49 169.78v25.17M520.77 167.52v25.56M522.14 166.06v24.79M523.33 163.87v25.41M524.61 162.22v25.04M525.89 160.03l.01 25.27M527.08 157.83v25.76M528.36 156.17v25.38M529.67 154.93v24.67M530.86 153.39v24.49M532.19 151.97l-.06 24.07M533.47 149.78l-.05 24.73M534.66 148.25l-.06 24.56M535.89 144.87v25.8M537.14 143.13v25.73M538.51 141.67v24.1M539.7 138.13v25.77M540.97 136.48v25.47M542.26 134.29v26.11M543.45 132.76v25.76M544.72 131.1v25.47M546.04 129.86v26.1M547.23 128.32v25.76M548.5 126.67v25.47M549.79 124.48v26.11M550.98 122.95v25.76M552.25 121.29v25.47M553.3 119.64v26.11M554.48 118.11v25.76M555.76 116.45v25.48'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
        }}
      />
      <path
        d='M495.98 229.48v-24.64'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-gP)',
        }}
      />
      <path
        d='M553.09 145.64v-25.7'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-gQ)',
        }}
      />
      <path
        d='M557.62 138.79V114.8l-67.54 98.86v24.47'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-61bdda9c5a-gR)',
        }}
      />
      <path
        d='M490.08 241.38v-27.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-61bdda9c5a-gS)',
        }}
      />
      <path
        d='M557.62 141.18V114.6'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-61bdda9c5a-gT)',
        }}
      />
    </g>
    <g
      id='unihockey'
    >
      <g
        id='unihockeyLeft'
      >
        <path
          d='M202.45 176.4l-43.49-3.18 40.64-25.68 40.87 2.72-38.02 26.14z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M184.79 386.87l-11.91-.75V385l20.86-12.45a3.13 3.13 0 0 1 2-.41l9.5 1.3v1.09L196 374a3.08 3.08 0 0 0-1.8.45l-16.7 10.12 7.27 1.23z'
          style={{
            fill: 'url(#s-61bdda9c5a-p)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M184.65 385.77l-11.77-.77 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.41.41 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.39.66-.93.64a.35.35 0 0 1-.27.09z'
          style={{
            fill: 'url(#s-61bdda9c5a-gU)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M204.57 353.37a26.14 26.14 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM204.52 352.79a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.1zM204.62 354.53a28.3 28.3 0 0 1-6.06-.6v-.11a28.14 28.14 0 0 0 6.47.6v.11zM204.6 354a27.29 27.29 0 0 1-5.93-.59v-.11a27.79 27.79 0 0 0 6.36.59v.11zM204.54 355.58a29.2 29.2 0 0 1-6.13-.58v-.11a29.41 29.41 0 0 0 6.62.58v.11zM204.63 355a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM204.59 356.75a31.53 31.53 0 0 1-6.47-.61v-.11a32.05 32.05 0 0 0 6.91.6v.11zM204.55 356.16a30.34 30.34 0 0 1-6.32-.58v-.11a30.52 30.52 0 0 0 6.8.58v.11zM204.64 357.91a33.93 33.93 0 0 1-6.74-.63v-.1a35.59 35.59 0 0 0 7.13.62v.11zM204.69 357.33a33.12 33.12 0 0 1-6.67-.68v-.11a32.79 32.79 0 0 0 7 .68v.1zM204.48 359.07a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM204.65 358.49a35.08 35.08 0 0 1-6.86-.64v-.1a35.89 35.89 0 0 0 7.24.63v.11zM204.54 360.12a38.53 38.53 0 0 1-7.08-.6v-.1a39.16 39.16 0 0 0 7.57.59v.11zM204.5 359.54a37.13 37.13 0 0 1-6.93-.59v-.11a37.25 37.25 0 0 0 7.46.59v.11zM204.73 361.28a41.38 41.38 0 0 1-7.47-.73v-.11a40 40 0 0 0 7.77.73v.11zM204.56 360.7a39.83 39.83 0 0 1-7.21-.6v-.11a39.5 39.5 0 0 0 7.68.6v.11zM204.7 361.87a42.41 42.41 0 0 1-7.56-.71v-.11a41.55 41.55 0 0 0 7.89.71v.1zM204.62 363a45.23 45.23 0 0 1-7.72-.64v-.11a45.06 45.06 0 0 0 8.13.64v.11zM204.7 362.45a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.11zM204.46 364.19a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM204.42 363.61a44.83 44.83 0 0 1-7.62-.58v-.11a45.17 45.17 0 0 0 8.23.58v.11zM204.5 365.36a49.85 49.85 0 0 1-8.07-.61v-.11a49.41 49.41 0 0 0 8.6.6v.11zM204.48 364.77a47.15 47.15 0 0 1-7.93-.6v-.1a49.14 49.14 0 0 0 8.49.59v.11zM204.52 366.41a51.15 51.15 0 0 1-8.29-.63v-.1a52.68 52.68 0 0 0 8.8.62v.1zM204.42 365.83a49.2 49.2 0 0 1-8.08-.59v-.1a50.92 50.92 0 0 0 8.7.57v.11zM204.42 367.57A54.21 54.21 0 0 1 196 367v-.11a54.44 54.44 0 0 0 9 .58v.11zM204.65 367a52.78 52.78 0 0 1-8.52-.72v-.1a53 53 0 0 0 8.9.71v.11zM204.37 368.73a55.51 55.51 0 0 1-8.6-.59V368a57.34 57.34 0 0 0 9.27.58v.11zM204.35 368.15a55 55 0 0 1-8.45-.58v-.11a55.7 55.7 0 0 0 9.14.58v.11zM204.42 369.9a59 59 0 0 1-8.88-.61v-.11a60.06 60.06 0 0 0 9.49.6v.11zM204.39 369.31a58.69 58.69 0 0 1-8.74-.59v-.11a58.61 58.61 0 0 0 9.38.59v.11zM204.46 371a63.37 63.37 0 0 1-9.12-.62v-.11a64 64 0 0 0 9.7.62v.1zM204.44 370.36a60.31 60.31 0 0 1-9-.61v-.1a61.16 61.16 0 0 0 9.58.6v.11zM204.36 372.11a66.15 66.15 0 0 1-9.26-.58v-.11a66.28 66.28 0 0 0 9.93.58v.11zM204.35 371.53a63.34 63.34 0 0 1-9.13-.58v-.11a66.58 66.58 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M192.91 152.41l-.11-.03 3.93-20.77.11.02-3.93 20.78zM193.8 152.41l-.11-.02 3.75-20.85.11.02-3.75 20.85zM200.81 152.95h-.11l.16-21.25h.11l-.16 21.25z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M192.49 362.27h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 90.16 253.657)'
        />
        <path
          d='M199.31 152.79h-.11l.44-21.1.11.01-.44 21.09zM196.67 152.64l-.11-.01 2.28-21.08.1.01-2.27 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M191.43 362.19h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 86.68 253.719)'
        />
        <path
          d='M189.52 362.06h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 74.153 253.73)'
        />
        <path
          d='M188.75 362.02h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 69.706 253.728)'
        />
        <path
          d='M197.73 152.64l-.11-.01 1.45-21.08.11.01-1.45 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M195.22 372.54l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-61bdda9c5a-gV)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M180.31 357.91h24.01v.08h-24.01z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -207.776 256.042)'
        />
        <path
          d='M176.92 357.88h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -214.82 253.219)'
        />
        <path
          d='M178.38 143.92l-.04-.07 20.53-12.33.04.07-20.53 12.33zM177.69 143.8l-.04-.07 20.27-12.17.04.07-20.27 12.17zM176.71 143.92l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M200.8 350.45h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 83.148 243.59)'
        />
        <path
          d='M199.9 351.22h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 66.656 244.336)'
        />
        <path
          d='M197.65 133.27l-2.55-.63.02-.07 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M198.64 352.2h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 37 245.462)'
        />
        <path
          d='M198.02 352.57h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 34.878 245.853)'
        />
        <path
          d='M182.06 361.4h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-85.98 62.61 254.937)'
        />
        <path
          d='M182.83 361.08h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 60.62 254.365)'
        />
        <path
          d='M183.73 360.66h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 54.981 253.915)'
        />
        <path
          d='M184.56 360.22h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.3 52.686 253.463)'
        />
        <path
          d='M190.95 137.32l-3.04-.43.01-.07 3.04.43-.01.07zM191.85 136.78l-3.01-.43.01-.08 3.01.43-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M185.53 359.65h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 53.773 252.896)'
        />
        <path
          d='M186.34 359.25h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 49.019 252.475)'
        />
        <path
          d='M187.15 358.71h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.91 54.368 251.93)'
        />
        <path
          d='M187.98 358.28h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 50.668 251.5)'
        />
        <path
          d='M187.25 139.55l-2.87-.57.01-.08 2.88.58-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M189.6 357.25h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.59 58.396 250.448)'
        />
        <path
          d='M196.86 352.85h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.04 64.414 246.163)'
        />
        <path
          d='M195.75 134.41l-2.44-.71.02-.07 2.44.71-.02.07zM194.66 135.08l-2.77-.54.02-.08 2.76.55-.01.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M195.41 353.89h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 61.018 247.002)'
        />
        <path
          d='M194.72 354.32h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 57.748 247.482)'
        />
        <path
          d='M194.05 354.72h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 56.18 247.885)'
        />
        <path
          d='M191.67 356.07h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 58.269 249.243)'
        />
        <path
          d='M189.43 138.24l-2.84-.57.02-.08 2.83.57-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M190.33 356.96h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 47.525 250.176)'
        />
        <path
          d='M172.54 377.63h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.403 272.927)'
        />
        <path
          d='M172.57 377.05h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.362 272.35)'
        />
        <path
          d='M172.73 376.43H197v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.21 271.727)'
        />
        <path
          d='M172.91 375.89h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.024 271.19)'
        />
        <path
          d='M172.94 375.3h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -217.319 271.089)'
        />
        <path
          d='M173.1 374.69h24.27v.11H173.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -217.172 270.482)'
        />
        <path
          d='M173.16 374.19h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.787 269.474)'
        />
        <path
          d='M173.37 373.67h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.57 268.967)'
        />
        <path
          d='M173.4 373.08h24.27v.11H173.4z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.547 268.385)'
        />
        <path
          d='M173.56 372.47h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.377 267.767)'
        />
        <path
          d='M173.74 371.92h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.209 267.226)'
        />
        <path
          d='M173.77 371.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.163 266.631)'
        />
        <path
          d='M173.93 370.73h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.016 266.026)'
        />
        <path
          d='M173.99 370.23h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.954 265.514)'
        />
        <path
          d='M174.09 369.66h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.858 264.953)'
        />
        <path
          d='M174.12 369.08h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.818 264.377)'
        />
        <path
          d='M174.27 368.46h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.666 263.753)'
        />
        <path
          d='M174.45 367.92h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.48 263.217)'
        />
        <path
          d='M174.48 367.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.457 262.636)'
        />
        <path
          d='M174.64 366.72h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.305 262.012)'
        />
        <path
          d='M174.7 366.22h24.27v.11H174.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.248 261.519)'
        />
        <path
          d='M174.88 365.55h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -215.384 261.326)'
        />
        <path
          d='M175.03 364.93h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.911 260.222)'
        />
        <path
          d='M175.22 364.39h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.725 259.686)'
        />
        <path
          d='M175.25 363.81h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.702 259.104)'
        />
        <path
          d='M175.4 363.19h24.27v.11H175.4z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.532 258.486)'
        />
        <path
          d='M175.46 362.69h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.475 257.992)'
        />
        <path
          d='M175.56 362.13h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.38 257.431)'
        />
        <path
          d='M175.59 361.55h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -214.672 257.306)'
        />
        <path
          d='M175.75 360.93h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.187 256.231)'
        />
        <path
          d='M175.93 360.39h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -214.339 256.162)'
        />
        <path
          d='M175.96 359.8h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.973 255.096)'
        />
        <path
          d='M176.11 359.19h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.826 254.49)'
        />
        <path
          d='M176.17 358.69h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.764 253.979)'
        />
        <path
          d='M166.66 374h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 41.422 265.798)'
        />
        <path
          d='M167.83 373.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 42.594 265.078)'
        />
        <path
          d='M167.24 373.67h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 42 265.467)'
        />
        <path
          d='M168.34 373h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 43.11 264.798)'
        />
        <path
          d='M169.51 372.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 44.276 264.072)'
        />
        <path
          d='M168.92 372.66h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 43.682 264.461)'
        />
        <path
          d='M170.02 372h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 45.608 264.455)'
        />
        <path
          d='M171.19 371.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.953 263.073)'
        />
        <path
          d='M170.6 371.66h20.58v.11H170.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.359 263.462)'
        />
        <path
          d='M171.71 370.99h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 46.469 262.793)'
        />
        <path
          d='M172.88 370.27h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 47.635 262.067)'
        />
        <path
          d='M172.28 370.66h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 47.04 262.456)'
        />
        <path
          d='M173.39 370.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.15 261.848)'
        />
        <path
          d='M174.56 369.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.323 261.128)'
        />
        <path
          d='M173.97 369.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.728 261.506)'
        />
        <path
          d='M175.08 369.04h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.833 260.843)'
        />
        <path
          d='M176.24 368.32h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 51.835 260.753)'
        />
        <path
          d='M175.65 368.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 50.415 260.505)'
        />
        <path
          d='M176.76 368.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 51.522 259.853)'
        />
        <path
          d='M177.93 367.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 52.694 259.133)'
        />
        <path
          d='M177.34 367.72h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 52.093 259.517)'
        />
        <path
          d='M178.44 367.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.203 258.848)'
        />
        <path
          d='M179.61 366.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.376 258.127)'
        />
        <path
          d='M179.02 366.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.775 258.511)'
        />
        <path
          d='M180.12 366.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.886 257.853)'
        />
        <path
          d='M181.29 365.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 56.052 257.128)'
        />
        <path
          d='M180.7 365.71h20.58v.11H180.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 55.463 257.51)'
        />
        <path
          d='M181.81 365.04h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 57.405 257.453)'
        />
        <path
          d='M182.98 364.32h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 58.573 256.723)'
        />
        <path
          d='M182.38 364.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 57.145 256.505)'
        />
        <path
          d='M183.49 364.1h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 58.255 255.897)'
        />
        <path
          d='M184.66 363.38h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 59.428 255.177)'
        />
        <path
          d='M184.07 363.76h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 58.827 255.56)'
        />
        <path
          d='M185.17 363.1h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 59.937 254.892)'
        />
        <path
          d='M185.75 362.76h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 60.509 254.555)'
        />
        <path
          d='M183.88 365.67a26.14 26.14 0 0 1-5.79-.58v-.11a25.75 25.75 0 0 0 6.25.58v.11zM183.83 365.09a23.72 23.72 0 0 1-5.49-.56v-.1a24.75 24.75 0 0 0 6 .55v.11zM183.93 366.84a27.66 27.66 0 0 1-6.06-.61v-.1a28.7 28.7 0 0 0 6.47.6v.1zM183.91 366.26a27.28 27.28 0 0 1-5.93-.6v-.1a27.81 27.81 0 0 0 6.36.58v.11zM183.85 367.89a28.54 28.54 0 0 1-6.13-.59v-.1a30 30 0 0 0 6.62.58v.1zM183.94 367.31a28.51 28.51 0 0 1-6.16-.62v-.1a28.94 28.94 0 0 0 6.56.6v.11zM183.9 369.05a31.6 31.6 0 0 1-6.47-.61v-.1a32.05 32.05 0 0 0 6.91.6v.11zM183.86 368.47a31 31 0 0 1-6.32-.58v-.11a31.76 31.76 0 0 0 6.8.58v.11zM184 370.21a34.72 34.72 0 0 1-6.74-.62v-.11a34.12 34.12 0 0 0 7.13.62v.11zM184 369.63a33.12 33.12 0 0 1-6.67-.68v-.1a33.43 33.43 0 0 0 7 .67v.11zM183.79 371.38a35.07 35.07 0 0 1-6.8-.59v-.1a36.83 36.83 0 0 0 7.35.58v.1zM184 370.79a35.1 35.1 0 0 1-6.86-.63v-.11a35.18 35.18 0 0 0 7.24.63v.11zM183.86 372.43a38.57 38.57 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.1zM183.81 371.85a36.28 36.28 0 0 1-6.93-.6v-.1a37.28 37.28 0 0 0 7.46.58v.11zM184 373.59a41.38 41.38 0 0 1-7.47-.73v-.11a40.88 40.88 0 0 0 7.77.73v.11zM183.87 373a39.8 39.8 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM184 374.17a41.5 41.5 0 0 1-7.56-.71v-.1a42.35 42.35 0 0 0 7.89.7v.11zM183.93 375.33a44.24 44.24 0 0 1-7.72-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM184 374.75a43.3 43.3 0 0 1-7.68-.71v-.11a42.57 42.57 0 0 0 8 .71v.11zM183.77 376.5a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM183.73 375.92a43.8 43.8 0 0 1-7.62-.59v-.1a46.08 46.08 0 0 0 8.23.58v.1zM183.81 377.66a48.74 48.74 0 0 1-8.07-.61v-.1a51.45 51.45 0 0 0 8.6.6v.11zM183.79 377.08a48.22 48.22 0 0 1-7.93-.6v-.11a49.1 49.1 0 0 0 8.49.6v.11zM183.82 378.71a51.16 51.16 0 0 1-8.28-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM183.73 378.13a50.4 50.4 0 0 1-8.08-.58v-.11a50.84 50.84 0 0 0 8.7.58v.11zM183.73 379.87a53 53 0 0 1-8.39-.58v-.11a53.37 53.37 0 0 0 9 .58v.11zM184 379.29a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM183.68 381a56.78 56.78 0 0 1-8.6-.59v-.11a58.45 58.45 0 0 0 9.27.59v.11zM183.66 380.46a53.72 53.72 0 0 1-8.45-.59v-.1a55.75 55.75 0 0 0 9.14.57v.11zM183.73 382.2a60.39 60.39 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM183.7 381.62a57.33 57.33 0 0 1-8.7-.62v-.11a58.64 58.64 0 0 0 9.38.6v.11zM183.77 383.25a62 62 0 0 1-9.12-.62v-.1a65.36 65.36 0 0 0 9.7.61v.11zM183.75 382.67a61.68 61.68 0 0 1-9-.61v-.11a62.33 62.33 0 0 0 9.58.61v.11zM183.67 384.41a64.66 64.66 0 0 1-9.26-.58v-.11a65.05 65.05 0 0 0 9.93.58v.11zM183.66 383.83a63.34 63.34 0 0 1-9.13-.58v-.11a64 64 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M172.22 164.71l-.11-.02 3.93-20.77.11.02-3.93 20.77zM173.11 164.71l-.11-.02 3.75-20.84.11.02-3.75 20.84zM180.12 165.25h-.11l.16-21.24h.11l-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M171.8 374.58H193v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 69.477 265.942)'
        />
        <path
          d='M178.62 165.1h-.11l.44-21.1h.11l-.44 21.1zM175.98 164.95l-.11-.01 2.28-21.09.1.01-2.27 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M170.75 374.5h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 65.996 266.024)'
        />
        <path
          d='M168.83 374.36h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 53.469 266.038)'
        />
        <path
          d='M168.06 374.32h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 49.021 266.031)'
        />
        <path
          d='M177.04 164.95l-.11-.01 1.45-21.09.11.01-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M174.38 384.87l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.74-1.34l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.84z'
          style={{
            fill: 'url(#s-61bdda9c5a-gW)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M184.86 386.72l-1-.41.07-22.07a1.53 1.53 0 0 1 .75-1.32l20.15-12.18a.4.4 0 0 1 .32 0l.75.22a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.7a.39.39 0 0 0-.59-.33l-18.12 10.94a1.57 1.57 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-61bdda9c5a-gX)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M185.08 386.59l-.29.28.07-22.1a1.57 1.57 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.34v20.63a3.11 3.11 0 0 1-.92 2.2v-21.18a.39.39 0 0 0-.59-.33L186.55 364a1.54 1.54 0 0 0-.75 1.33v19.54a2.51 2.51 0 0 1-.72 1.72z'
          style={{
            fill: 'url(#s-61bdda9c5a-gY)',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
      <g
        id='unihockeyRight'
      >
        <path
          d='M928.9 226.41l-50.89-3.71-4.01-31.69 45.53 2.54 9.37 32.86z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M916.93 218.34l10.95.63v-1l-6.54-19.46-9.71.21v1l8.5.48 5.45 17.04-8.65.1v1z'
          style={{
            fill: 'url(#s-61bdda9c5a-gZ)',
          }}
        />
        <path
          d='M916.95 217.34l10.93.63-6.54-19.46-10.16-.47.53.68 9.03.51 5.86 18.06-9.85-.56.2.61z'
          style={{
            fill: 'url(#s-61bdda9c5a-ha)',
          }}
        />
        <path
          d='M923.8 419.59c-1 0-2.08 0-3.29-.13v-.1a36.92 36.92 0 0 0 7-.08v.1a34.17 34.17 0 0 1-3.71.21zM923.74 419.06c-1 0-2 0-3.18-.13v-.1a33.3 33.3 0 0 0 6.73-.07v.1a31.9 31.9 0 0 1-3.55.2zM923.78 420.64c-1.06 0-2.17 0-3.36-.13v-.1a38.74 38.74 0 0 0 7.26-.08v.1a36.22 36.22 0 0 1-3.9.21zM923.78 420.11c-1 0-2.12 0-3.31-.13v-.1a37.51 37.51 0 0 0 7.14-.07v.1a35.15 35.15 0 0 1-3.83.2zM924 421.61c-1.12 0-2.29-.05-3.62-.15v-.1a39.81 39.81 0 0 0 7.43-.05v.1c-1.36.13-2.57.2-3.81.2zM923.78 421.07c-1.08 0-2.21-.05-3.4-.13v-.1a40.71 40.71 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM924 422.66c-1.18 0-2.41-.05-3.74-.14v-.1a45.28 45.28 0 0 0 7.75-.05v.09a38.24 38.24 0 0 1-4.01.2zM924.1 422.14c-1.18 0-2.42-.05-3.81-.15v-.1a42.75 42.75 0 0 0 7.62 0v.1a37.21 37.21 0 0 1-3.81.15zM924 423.71c-1.24 0-2.52 0-3.84-.14v-.1a47.18 47.18 0 0 0 8-.05v.1c-1.32.13-2.72.19-4.16.19zM923.52 423.16c-1.1 0-2.19 0-3.32-.12v-.1a44.94 44.94 0 0 0 7.86-.1v.1c-1.55.15-3.06.22-4.54.22zM924.37 424.79c-1.33 0-2.71-.05-4.31-.17v-.1a50.36 50.36 0 0 0 8.24 0v.1c-1.3.12-2.61.17-3.93.17zM924 424.24c-1.26 0-2.57-.05-3.88-.14v-.1a49.65 49.65 0 0 0 8.12-.06v.1c-1.32.13-2.76.2-4.24.2zM924.41 425.74c-1.39 0-2.84-.05-4.43-.17v-.1a53.46 53.46 0 0 0 8.49 0v.1c-1.34.12-2.67.17-4.06.17zM924.4 425.22c-1.36 0-2.77-.06-4.37-.17V425a50.65 50.65 0 0 0 8.36 0v.1c-1.39.06-2.65.12-3.99.12zM923.47 426.75c-1.12 0-2.32 0-3.58-.12v-.1a54.92 54.92 0 0 0 8.72-.11v.1c-1.4.12-3.14.23-5.14.23zM924.43 426.27c-1.43 0-2.91-.06-4.5-.17v-.1a55.11 55.11 0 0 0 8.62 0v.09c-1.34.13-2.7.18-4.12.18zM923.74 427.29c-1.32 0-2.61 0-3.9-.14v-.09a57.07 57.07 0 0 0 8.85-.08v.1c-1.69.14-3.33.21-4.95.21zM924.51 428.38c-1.56 0-3.17-.06-4.76-.17v-.1a61.62 61.62 0 0 0 9.12 0v.1c-1.34.11-2.87.17-4.36.17zM923.8 427.82c-1.36 0-2.69 0-4-.14v-.1a58.79 58.79 0 0 0 9-.06v.1c-1.69.13-3.36.2-5 .2zM925 429.47c-1.66 0-3.38-.07-5.32-.21v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.38.09-2.71.14-4.06.14zM924.92 428.94c-1.61 0-3.26-.07-5.21-.21v-.09a62 62 0 0 0 9.22.06v.1c-1.39.09-2.68.14-4.01.14zM925.05 430.52c-1.73 0-3.54-.07-5.48-.2v-.1a69.22 69.22 0 0 0 9.63.07v.09c-1.35.1-2.73.14-4.15.14zM925 430c-1.7 0-3.46-.06-5.41-.2v-.1a67.51 67.51 0 0 0 9.51.07v.1c-1.34.13-2.69.13-4.1.13zM925.29 431.48c-1.66 0-3.38-.07-5.32-.21v-.1a65.56 65.56 0 0 0 9.37.07v.1c-1.34.09-2.68.14-4.05.14zM925.39 431c-1.81 0-3.73-.08-5.86-.23v-.1a69.8 69.8 0 0 0 9.74.1v.1c-1.27.05-2.53.13-3.88.13zM925.83 432.56c-1.73 0-3.58-.07-5.81-.23v-.1a66 66 0 0 0 9.45.11v.1c-1.19.08-2.38.12-3.64.12zM924.58 432c-1.52 0-3 0-4.61-.17v-.1a64.64 64.64 0 0 0 9.44 0v.1c-1.73.08-3.3.17-4.83.17zM925.86 433.62c-1.68 0-3.37-.07-5.67-.23v-.1a67.71 67.71 0 0 0 9.49.12v.1c-1.42.07-2.62.11-3.82.11zM925.78 433.1c-1.64 0-3.29-.08-5.59-.24v-.1a64.86 64.86 0 0 0 9.39.12v.1c-1.42.08-2.58.12-3.8.12zM925.33 434.71c-1.57 0-3.21-.06-5.27-.21v-.1a70 70 0 0 0 9.79.06v.1c-1.63.09-3.04.15-4.52.15zM925.91 434.15c-1.74 0-3.5-.08-5.79-.24v-.1a68.56 68.56 0 0 0 9.65.13v.1c-1.4.07-2.63.11-3.86.11zM925.4 435.66c-1.62 0-3.34-.06-5.43-.21v-.1a73.34 73.34 0 0 0 10 .07v.1c-1.56.08-2.97.14-4.57.14zM925.36 435.13c-1.59 0-3.27-.06-5.34-.2v-.1a71.3 71.3 0 0 0 9.88.06v.1c-1.59.09-3.02.14-4.54.14zM926 436.74c-1.92 0-3.85-.08-6.08-.23v-.1a77.1 77.1 0 0 0 10.27.11v.1c-1.48.08-2.85.12-4.19.12zM925.84 436.21c-1.87 0-3.73-.08-5.91-.23v-.1a75.2 75.2 0 0 0 10.15.11v.1a78.3 78.3 0 0 1-4.24.12z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.41 217.59l-2.3-19.24.1-.01 2.3 19.23-.1.02z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M927.36 418.24h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -1246.774 346.613)'
        />
        <path
          d='M917.92 217.14h-.1l.08-19.18h.1l-.08 19.18zM918.59 217.12h-.1l.08-19.08h.1l-.08 19.08zM919.31 217.25h-.1l.14-19.21h.1l-.14 19.21z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M924.83 418.2h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -7107.003 424.553)'
        />
        <path
          d='M920.19 198.04h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M925.53 418.22h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -4350.17 388.139)'
        />
        <path
          d='M926.5 418.24h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -2134.66 358.317)'
        />
        <path
          d='M923.94 418.12h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -14647.148 523.201)'
        />
        <path
          d='M917.36 401c-.7 0-1.44 0-2.26-.07v-.1a29.11 29.11 0 0 0 6.2-.21v.09a26.52 26.52 0 0 1-3.94.29zM917.37 400.47c-.68 0-1.4 0-2.24-.08v-.1a26.31 26.31 0 0 0 6-.21v.1a24.21 24.21 0 0 1-3.76.29zM917.29 402q-1.06 0-2.25-.06v-.1a30.61 30.61 0 0 0 6.43-.23v.1a28.75 28.75 0 0 1-4.18.29zM917.31 401.5c-.7 0-1.44 0-2.24-.07v-.1a29.47 29.47 0 0 0 6.31-.22v.1a27.68 27.68 0 0 1-4.07.29zM917.47 403c-.77 0-1.58 0-2.48-.08v-.1a32.83 32.83 0 0 0 6.58-.2v.1a30 30 0 0 1-4.1.28zM917.27 402.44q-1.08 0-2.25-.06v-.1a32.19 32.19 0 0 0 6.52-.23v.1a29.67 29.67 0 0 1-4.27.29zM917.43 404c-.8 0-1.63 0-2.51-.08v-.1a34.89 34.89 0 0 0 6.86-.21v.1a32.84 32.84 0 0 1-4.35.29zM917.54 403.5c-.81 0-1.66 0-2.58-.08v-.1a34.35 34.35 0 0 0 6.75-.19v.1a31.57 31.57 0 0 1-4.17.27zM917.36 405.06c-.82 0-1.65 0-2.5-.08v-.1a37.21 37.21 0 0 0 7.08-.21v.1a35.48 35.48 0 0 1-4.58.29zM917 404.53c-.7 0-1.41 0-2.14-.07v-.1a36.16 36.16 0 0 0 7-.26v.1a36.45 36.45 0 0 1-4.86.33zM917.75 406.12c-.91 0-1.88 0-3-.09v-.1a39.5 39.5 0 0 0 7.29-.17v.1a35.66 35.66 0 0 1-4.29.26zM917.33 405.58c-.82 0-1.66 0-2.5-.08v-.09a39.22 39.22 0 0 0 7.19-.22v.1a36.76 36.76 0 0 1-4.69.29zM917.7 407.06c-.94 0-1.91 0-3-.09v-.1a42.08 42.08 0 0 0 7.52-.17v.1a40.41 40.41 0 0 1-4.52.26zM917.74 406.54c-.92 0-1.9 0-3-.09v-.1a40.69 40.69 0 0 0 7.4-.17v.1a39.1 39.1 0 0 1-4.4.26zM916.92 408.07c-.72 0-1.46 0-2.24-.06v-.1a43.49 43.49 0 0 0 7.72-.28v.1a47.32 47.32 0 0 1-5.48.34zM917.69 407.58c-1 0-1.94 0-3-.09v-.1a43.31 43.31 0 0 0 7.63-.17v.1a41.62 41.62 0 0 1-4.63.26zM917.1 408.6c-.82 0-1.64 0-2.45-.07v-.1a44.33 44.33 0 0 0 7.84-.25v.1a46.09 46.09 0 0 1-5.39.32zM917.62 409.66c-1 0-2 0-3-.08v-.1a49.57 49.57 0 0 0 8.07-.18v.09a44.57 44.57 0 0 1-5.07.27zM917.12 409.12c-.85 0-1.68 0-2.5-.07V409a46.36 46.36 0 0 0 8-.24v.1a48.54 48.54 0 0 1-5.5.26zM918.1 410.73c-1.12 0-2.29 0-3.57-.11v-.1a52.77 52.77 0 0 0 8.31-.12v.1c-1.59.15-3.11.23-4.74.23zM918.12 410.21c-1.1 0-2.26 0-3.56-.11v-.1a49.86 49.86 0 0 0 8.17-.12v.1c-1.59.15-3.05.23-4.61.23zM918.09 411.77c-1.16 0-2.36 0-3.62-.11v-.1a54.38 54.38 0 0 0 8.53-.12v.1c-1.59.15-3.21.23-4.91.23zM918.1 411.25c-1.14 0-2.33 0-3.6-.11V411a53 53 0 0 0 8.42-.12v.1c-1.59.19-3.16.27-4.82.27zM918.09 412.71c-1.18 0-2.41 0-3.68-.11v-.1a55.67 55.67 0 0 0 8.73-.13v.1c-1.61.16-3.28.24-5.05.24zM918.38 412.2c-1.23 0-2.53 0-3.94-.12V412a54 54 0 0 0 8.62-.1v.1a46.63 46.63 0 0 1-4.68.2zM918.55 413.77q-2 0-4.2-.12v-.1a59 59 0 0 0 8.93-.09v.1c-1.42.14-3.01.21-4.73.21zM917.41 413.21c-1 0-2 0-3-.08V413a57.26 57.26 0 0 0 8.83-.21v.1c-2.02.22-3.94.32-5.83.32zM918.56 414.82c-1.33 0-2.72 0-4.27-.13v-.1a63.34 63.34 0 0 0 9.19-.08v.1c-1.67.14-3.25.21-4.92.21zM918.55 414.3c-1.3 0-2.67 0-4.23-.13v-.1a61.71 61.71 0 0 0 9.07-.08v.1c-1.67.14-3.21.21-4.84.21zM918.57 415.86c-1.37 0-2.8 0-4.35-.13v-.1a65 65 0 0 0 9.41-.08v.1c-1.63.14-3.32.21-5.06.21zM918.57 415.34c-1.35 0-2.76 0-4.31-.13v-.1a63.45 63.45 0 0 0 9.3-.08v.1c-1.67.14-3.29.21-4.99.21zM918.57 416.8c-1.41 0-2.87 0-4.4-.12v-.1a69.38 69.38 0 0 0 9.62-.09v.1c-1.67.14-3.41.21-5.22.21zM918.57 416.28c-1.39 0-2.84 0-4.37-.13v-.1a66.26 66.26 0 0 0 9.5-.08v.1c-1.7.14-3.36.21-5.13.21zM919.09 417.86c-1.56 0-3.23 0-5-.14v-.1a72.6 72.6 0 0 0 9.85 0v.1c-1.46.08-3.09.14-4.85.14zM919 417.34c-1.52 0-3.14 0-4.87-.14v-.1a70.92 70.92 0 0 0 9.74-.05v.1c-1.5.13-3.12.19-4.87.19z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M922.04 399.69h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -835.662 322.523)'
        />
        <path
          d='M921.32 399.58h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -1093.094 325.588)'
        />
        <path
          d='M912.45 198.53l-.03-19.11h.1l.03 19.11h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M916.04 399.6h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -96056.064 1596.68)'
        />
        <path
          d='M916.81 399.6h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -39774.96 833.162)'
        />
        <path
          d='M916.56 198.45l-.81-18.94h.1l.81 18.94h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M917.6 399.6h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -15896.953 521.641)'
        />
        <path
          d='M919.7 399.59h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -3021.376 351.28)'
        />
        <path
          d='M920.56 399.59h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -1734.463 334.182)'
        />
        <path
          d='M918.35 399.5h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -8027.35 416.936)'
        />
        <path
          d='M923.67 419l-2.19-18.14c-.07-.78-.94-.92-1.66-.9l-6-.2v-.57l6 .2c1.89 0 2.18 1 2.22 1.42l2.19 18.12z'
          style={{
            fill: 'url(#s-61bdda9c5a-hb)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M924.37 420.28l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M924.84 421.56l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2V402l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M925.34 423.17L923.15 405a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M925.79 424.32l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.25 425.66l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2V406l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.72 427l-2.19-18.13a1.32 1.32 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M927.22 428.62L925 410.49a1.31 1.31 0 0 0-1.24-1.19l-6-.19V409l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M927.71 430l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M928.18 431.47L926 413.34a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M928.66 432.91l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.17 434.65L927 416.51a1.31 1.31 0 0 0-1.24-1.18l-6-.2V415l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.64 436l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.28l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.9 437.58l-2.19-18.13a1.08 1.08 0 0 0-1-1l-6.38-.19v-.57l6.38.19a1.65 1.65 0 0 1 1.57 1.49l2.19 18.13z'
          style={{
            fill: 'url(#s-61bdda9c5a-hc)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M918.31 398.96h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 216.36 307.822)'
        />
        <path
          d='M919.46 399.07h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 201.838 308.221)'
        />
        <path
          d='M920.52 198.05l-5.71-18.56.1-.03 5.71 18.56-.1.03zM921.81 198.05l-6.09-18.61.1-.03 6.09 18.61-.1.03zM922.88 198.06l-6.31-18.52.09-.04 6.31 18.52-.09.04z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M923.76 399.21h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 253.852 307.84)'
        />
        <path
          d='M920.06 438.62a.57.57 0 0 1-.57-.57v-20.11l-4.72-14.73v16.45a.56.56 0 0 1-.57.57.57.57 0 0 1-.57-.57v-20.11a.57.57 0 0 1 1.12-.17l5.83 18.2a.7.7 0 0 1 0 .25v20.22a.58.58 0 0 1-.52.57z'
          style={{
            fill: 'url(#s-61bdda9c5a-hd)',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '36x18'
})
